/* eslint-disable react/prop-types */
import Axios from 'axios';
import React, { Component } from 'react';
import './assets/css/mystyle.pcss';
import ClearSessionOverlay from './src/Components/BaseComponents/ClearSessionOverlay';
import BotIcon from './src/Components/FeatureComponents/BotIcon';
import Header from './src/Components/FeatureComponents/Header';
import DataAPI from './src/Utils/Api';
import MDUtil from './src/Utils/MDUtil';
import debounce, { debounce2 } from './src/Utils/Reactive';
import TimeUtil from './src/Utils/TimeUtil';
import { TString } from './src/Components/FeatureComponents/Response/Utils';
import { SessionTimeout } from './src/Components/FeatureComponents/SessionTimeout';
import Timer from './src/Utils/Timer';
import { getMinutesFromHHMM } from './src/Utils/General';
import { getLabelTranslation } from './src/Components/FeatureComponents/Response/Utils';
import CryptoJS from 'crypto-js';
// eslint-disable-next-line @typescript-eslint/no-var-requires
let ES6Promise = require('es6-promise');
ES6Promise.polyfill();
import { TOASTER } from './src/Components/FeatureComponents/ChatBody';
import ChatBody from './src/Components/FeatureComponents/ChatBody';
import LoginScreen from './src/Components/FeatureComponents/LoginScreen';
import SFModal from './src/Components/BaseComponents/SFModal';

import {
	anchorTagClickHandler,
	// hexCodeToRGBA
} from './src/Components/FeatureComponents/Response/Utils';
import {
	MatchedNodeContext,
	CurrentLanguageContext,
	LanguageContext,
	InternationalizationContext,
	truthyOrFalsy,
} from './src/Utils/Contexts';
import {
	LabelInternationalization,
	ToasterIdentifier,
} from './src/Utils/constants';

import LangModal from './src/Components/FeatureComponents/ModalPane/LangModal';
import LoaderModal from './src/Components/FeatureComponents/ModalPane/LoaderModal';
import MessageFeedbackComment from './src/Components/FeatureComponents/MessageFeedback/MessageFeedbackComment';
import { ButtonItem } from 'src/Components/FeatureComponents/ModalPane/ModalPane';
import {
	ChatSocketRequest,
	SocketMessages,
	BanglaSocketMessages,
	LiveChatMessageTypes,
	AgentActions,
	MessageSource,
	AuxiliaryActions,
	MediaMetaType,
} from './src/Utils/models';
import WebSocketClient from './src/Utils/SocketClient';
import { Toaster } from './src/Components/FeatureComponents/Toaster';
import { WaitingForAgent } from './src/Components/FeatureComponents/LiveChat/WaitingForAgent';
import { Chatting } from './src/Components/FeatureComponents/LiveChat/Chatting';
import { CancelTransfer } from './src/Components/FeatureComponents/LiveChat/CancelTransfer';
import { init } from './src/Utils/PushNotification';
import { DisconnectingFromAgent } from './src/Components/FeatureComponents/LiveChat/DisconnectingFromAgent';
import botLogo from './assets/imgs/shopify-bot.png';
import { ThemedPencil } from 'src/Components/FeatureComponents/Buttons/IconButton/Icons';
import { CloseBotArrow } from './src/Components/FeatureComponents/Buttons/IconButton/Icons';
import {
	loadState,
	loadStateSession,
	removeStateSession,
	saveStateSession,
} from './src/Components/FlyfishComponents/flyfishutils/utils';
import EcomTheme from './src/Components/FeatureComponents/Flyfish/EcomTheme';
import EcomNewSearch from './src/Components/FeatureComponents/Flyfish/EcomNewSearch';
import EcomSearch from './src/Components/FeatureComponents/Flyfish/EcomSearch';
import VoiceModal from './src/Components/FeatureComponents/VoiceModal';
import './index.scss';
declare const BASE_URL: string;
declare const CHAT_URL: string;
declare const window: any;
interface Message {
	message;
	timeStamp;
	key;
	messageType;
	customInfos;
	suggestionChips;
	hidden?;
}

interface Props {
	botName;
	botWelcomeMessage;
	botQuickLinks;
	botID;
	data;
	tenantID;
	showBot;
	currentResponseType?: string;
	eB: string;
	token;
	colorScale;
}

interface State {
	isBotVisible;
	isOverlayVisible;
	redirectURL: string;
	isChatBodyVisible;
	showWelcomeScreen: boolean;
	chatMessages: Message[];
	chatInput;
	isSpeech;
	isModalVisible;
	predSearchToggle;
	predSearchResponse;
	selectedTheme;
	userQuery;
	failedCount;
	notifications;
	showcancelMessage: string;
	polls;
	surveys;
	freshChatSocketStatus: boolean;
	isUserLoggedin;
	disableGetInTouch;
	toShowRedDot;
	disableDotOnceClick;
	isChatInputDisabled;
	conversationalId;
	isAutoSuggest: boolean;
	logoutMessage;
	bearerToken;
	secondAPI;
	autoSuggestApiDetails: {
		apiURL: string;
		methodType: string;
		apiPayload: { key: string; value: string }[];
		apiHeader: { key: string; value: string }[];
		errorMessage: string;
	};
	suggestions: {
		response: { value: string }[];
	};
	taskId: number;
	workflowId: number;
	currentLanguageCode: string;
	targetLangCode: string;
	languageCodes: { [k: string]: string };
	botName: string;
	welcomeMessage: string;
	showLangConfirmation: boolean;
	isLanguageListVisible: boolean;
	toasterBodyIdentifier: ToasterIdentifier;
	isConnectedToNetwork: boolean;
	showLoginScreen: boolean;
	oauthURL: string;
	speakingEnabled: boolean;
	uniqueId: {
		sfUniqueId: string;
		time: number;
	};
	feedbackDone: boolean;
	showFeedback: boolean;
	botClosingModal: boolean;
	snackBarMessage: string;
	simplifiedLangCodes;
	messageFeedbackComment: any;
	messageFeedbackRating: boolean;
	messageFeedbackCallback: Function;
	messageFeedbackPrevVal: string;
	toasterMessageTemplate: {
		message: any;
		buttons: ButtonItem[];
		showIcon: boolean;
	};
	internalFeedbackErrorBlock: boolean;
	isChatInputHidden: boolean;
	isBotSessionTimeout: boolean;
	sessionComplete: boolean;
	data: any;
	lastScroll: number;
	disableRefresh: boolean;
	voiceResponse: boolean;
	showLoader: boolean;
	isChatStarted: boolean;
	sessionCleared: boolean;
	launcherPromptMessage: string;
	isDisconnectingFromAgent: boolean;
	isConnectedWithAgent: boolean;
	userDetailsPopup: number;
	handleUserDetailsPopUponTakeover: boolean;
	connectSocketAfterUserDetails: boolean;
	socketValidation: number;
	collectUserDetails: boolean;
	wsendpointSocketStatus: string;
	sessionID: string;
	IPaddress: string;
	isUserNameNeeded: boolean;
	isuserLastNameNeeded: boolean;
	isUserContactNeeded: boolean;
	positionInQueue: number;
	selectedProduct: any;
	isWaitingForAgent: boolean;
	isCancellingTransfer: boolean;
	userDetailName: string;
	userDetailLastName: string;
	userDetailContact: string;
	liveAgentName: string;
	showDisconnectMsg: boolean;
	wsagentinterventionSocket: boolean;
	hasSessionExpired: boolean;
	isLoadedFromAgentDashboard: boolean;
	disableSessionConfirmBtn: boolean;
	SelectedCountryCode: string;
	countryCodes: {
		name: string;
		callingCodes: string;
		flag: string;
	}[];
	disableUserDetailBtn: string;
	showThumbs: boolean;
	encryptbotId: string;
	callUniqueApi: boolean;
	channel?: string;
	productDetails;
	cartActions;
	variantId;
	cartExist: boolean;
	cartId: '';
	paymentId;
	paymentStatus;
	currentScreen: string;
	selectedColor: string;
	formChatInputHidden: boolean;
	mandatoryCollection: boolean;
	detailCollection: boolean;
	showFeedbackPopup: boolean;
	thumbFilledUp: boolean;
	thumbFilledDown: boolean;
	messageId: number;
	productCarousel;
	showForm;
	showToaster: boolean;
	currentCountry: string;
	reason: any;
	voiceText: string;
	enableVoiceModal: boolean;
}

enum ChatThemes {
	'Theme1',
	'Theme2',
	'Theme3',
	'null' = null,
}
var socketcount = 0;
var takeoversocketOpenCount = 0;
var portApiName =
	window.location.origin.indexOf('https') > -1 ? 'https://' : 'https://';
var socketName = window.location.origin.indexOf('https') > -1 ? 'wss' : 'ws';

//OverRide the css..

const AppStyles = (props) => {
	return props.styles.botId == 138 ? (
		<style
			dangerouslySetInnerHTML={{
				__html: `
@import url('https://fonts.googleapis.com/css?family=Source+Sans+Pro');
.sf-chatbot{
font-family : 'Open Sans', sans-serif;
}
`,
			}}
		/>
	) : null;
};
let onlySpecialCharactersEntered = false;
const { countries, zones } = require('moment-timezone/data/meta/latest.json');
const timeZoneToCountry = {};
const timeZoneCityToCountry = {};
const ChatStyles = (props) => {
	return props.styles.chatBackgroundWallpaper &&
		props.styles.chatBackgroundWallpaper.length > 0 ? (
		<style
			dangerouslySetInnerHTML={{
				__html: `
.sf-chatbody{
background: url("${props.styles.chatBackgroundWallpaper}") 0% 0% / cover no-repeat;
}
`,
			}}
		/>
	) : null;
};

let SFIconStyles = (props) => {
	return props.styles.botId == 138 ? (
		<style
			dangerouslySetInnerHTML={{
				__html: `
@media only screen and (min-width: 800px) {
.sf-bot-icon{
right : 150px;
}
}
`,
			}}
		/>
	) : null;
};

let _originalSize = window.innerWidth + window.innerHeight;
const styleVars = getComputedStyle(document.querySelector(':root'));

function getThemeValue(botSkin) {
	var themeType = JSON.parse('1');
	// console.log(themeType);
	return themeType == 0 ? null : `Theme${themeType}`;
}

class App extends Component<Props, State> {
	private box: React.RefObject<HTMLInputElement>;
	audioArray = [];
	pauseAudio: boolean;
	audioWebsocket;
	micUsed: boolean;
	sessionTimer: ReturnType<typeof setTimeout>;
	private handleWindowBeforeUnload = (ev: BeforeUnloadEvent): string => {
		const isLoadedFromAgentDashboard =
			window.location.href.indexOf('source=agent') > -1;

		return 'Unsaved changes. Are you sure?';
	};
	chatSocket: WebSocketClient = null;
	takeoverSocket: WebSocket = null;
	freshChatSocket: WebSocket = null;
	LivechatSocket: WebSocket = null;

	constructor(props) {
		super(props);
		this.state = this.setInitialState();
		this.box = React.createRef();
		this.clearSessionInterval = this.clearSessionInterval.bind(this);
		this.clearPaymentInterval = this.clearPaymentInterval.bind(this);
		this.activeSessionInterval = this.activeSessionInterval.bind(this);
		this.callwebsocket = this.callwebsocket.bind(this);
		// this.callOpenSocket = this.callOpenSocket.bind(this);
		this.wsAgentInterventionheartbeat =
			this.wsAgentInterventionheartbeat.bind(this);
		this.apiclearsession = this.apiclearsession.bind(this);
		this.clearSession = this.clearSession.bind(this);
		this.addUserResponse = this.addUserResponse.bind(this);
		this.HideWelcomeScreen = this.HideWelcomeScreen.bind(this);
		this.changeScreen = this.changeScreen.bind(this);
		this.RefreshSession = this.RefreshSession.bind(this);
		this.handleMessage = this.handleMessage.bind(this);
	}

	setInitialState = (): State => {
		var selectedThemeNumber = getThemeValue(this.props.data.botSkin);
		const botWelcomeMessage = this.props.data.botWelcomeMessage
			? this.props.data.botWelcomeMessage
			: "Hi, I'm a Chatbot. Please select a quick link below or type your question in the space provided.";
		let welcomeMessage =
			this.props.data &&
			this.props.data.dynamicMessages &&
			this.props.data.welcomeMessageType?.toLowerCase() === 'dynamic'
				? this.getDynamicWelcomeMessage(this.props.data.dynamicMessages)
				: botWelcomeMessage;
		if (this.props.data.isBotFrozen === 'true') {
			welcomeMessage =
				'Sorry, the bot has been disabled and is not available to chat with. Please contact the bot administrator.';
		}
		let defLang =
			this.state && this.state.currentLanguageCode
				? this.state.currentLanguageCode
				: this.props.data.defaultLanguage
				? this.props.data.defaultLanguage
				: 'en';
		// console.log(
		// 	this.props.data.isInsideKampsta,
		// 	this.props.data.isInsideCampaign
		// );
		return {
			reason: '',
			secondAPI: '',
			bearerToken: this.props.token,
			freshChatSocketStatus: false,
			currentCountry: loadStateSession('FS-country'),
			showToaster: false,
			userQuery: '',
			failedCount: 0,
			isLanguageListVisible:
				this.props.data.showLangModal === 'true' ? true : false,
			selectedTheme: selectedThemeNumber != null ? selectedThemeNumber : null,
			conversationalId: 0,
			productDetails: '',
			disableGetInTouch: false,
			redirectURL: '',
			productCarousel: false,
			showcancelMessage: '',
			selectedProduct: {},
			showForm: false,
			cartActions: '',
			// isBotVisible: true,
			isBotVisible: true,
			isOverlayVisible: false,
			isChatBodyVisible: true,
			showWelcomeScreen: false,
			formChatInputHidden: false,
			mandatoryCollection:
				this.props.data.additionalsettingMandatoryCollection.toLowerCase() ==
				'true'
					? true
					: false,
			detailCollection:
				this.props.data.additionalsettingDetailsCollection.toLowerCase() ==
				'true'
					? true
					: false,
			chatMessages:
				this.props.data.selectedTheme === 'monaco' ||
				this.props.data.selectedTheme === 'E-commerce Chat' ||
				window.location.search.indexOf('skipHome=true') === -1 ||
				this.props.data.botName.toLowerCase().indexOf('fractal') > -1
					? //  ||

					  []
					: [
							{
								message: [
									{
										displayResponse:
											loadStateSession('channel') === 'whatsapp'
												? 'whatsapp'
												: welcomeMessage,
										responseType: 'SIMPLE',
									},
								],
								timeStamp: '', //TimeUtil.getCurrentTime(new Date()),
								key: null,
								messageType: 'server',
								customInfos: {},
								suggestionChips: [],
							},
					  ],
			chatInput: '',
			// #TODO : Move down to the Mic Component use the ThemeContext API
			// Have to do the same with all the lower down childs
			// Context should be avoided whenever the job can be done with passing props
			isSpeech: this.props.data.voiceSupport,
			isModalVisible: false,
			predSearchToggle: false,
			cartExist: false,
			predSearchResponse: [],
			notifications: [],
			polls: [],
			surveys: [],
			isUserLoggedin: false,
			logoutMessage: '',
			toShowRedDot: false,
			disableDotOnceClick: true,
			isChatInputDisabled: false,
			isAutoSuggest: false,
			autoSuggestApiDetails: {
				apiURL: '',
				methodType: '',
				apiPayload: [],
				apiHeader: [],
				errorMessage: '',
			},
			suggestions: {
				response: [],
			},
			taskId: 0,
			workflowId: 0,
			currentLanguageCode: defLang,
			// this.props.data.defaultLanguage
			//   ? this.props.data.defaultLanguage
			//   : 'en',
			targetLangCode: '',
			languageCodes: {},
			botName: this.props.botName,
			welcomeMessage: welcomeMessage,
			showLangConfirmation: false,
			toasterBodyIdentifier: ToasterIdentifier.None,
			isConnectedToNetwork: true,
			showLoginScreen: false,
			oauthURL: '',
			speakingEnabled: true,
			uniqueId: null,
			feedbackDone: false,
			showFeedback: false,
			botClosingModal: true,
			snackBarMessage: '',
			simplifiedLangCodes: [],
			messageFeedbackComment: null,
			messageFeedbackRating: false,
			messageFeedbackCallback: () => {},
			messageFeedbackPrevVal: '',
			toasterMessageTemplate: {
				message: '',
				buttons: [],
				showIcon: false,
			},
			internalFeedbackErrorBlock: false,
			isChatInputHidden: false,
			isBotSessionTimeout: false,
			sessionComplete: false,
			data: this.props.data,
			lastScroll: null,
			disableRefresh: false,
			voiceResponse: false,
			showLoader: false,
			isChatStarted: false,
			sessionCleared: false,
			launcherPromptMessage: this.props.data.launcherPromptMessage,
			isDisconnectingFromAgent: false,
			isConnectedWithAgent: false,
			userDetailsPopup: 0,
			handleUserDetailsPopUponTakeover: false,
			connectSocketAfterUserDetails: false,
			socketValidation: 0,
			collectUserDetails: false,
			wsendpointSocketStatus: '',
			sessionID: '',
			IPaddress: '127.0.0.1',
			isUserNameNeeded: false,
			isuserLastNameNeeded: false,
			isUserContactNeeded: false,
			positionInQueue: -1,
			isWaitingForAgent: false,
			isCancellingTransfer: false,
			userDetailName: '',
			userDetailLastName: '',
			userDetailContact: '',
			liveAgentName: '',
			showDisconnectMsg: false,
			wsagentinterventionSocket: false,
			hasSessionExpired: false,
			isLoadedFromAgentDashboard: false,
			disableSessionConfirmBtn: false,
			SelectedCountryCode: '+91',
			countryCodes: [],
			disableUserDetailBtn: '',
			showThumbs: true,
			encryptbotId: '',
			callUniqueApi: false,
			channel: loadStateSession('channel'),
			variantId: '',
			cartId: '',
			paymentId: '',
			paymentStatus: '',
			// channel: 'whatsapp',
			currentScreen:
				window.location.search.indexOf('skipHome=true') > -1
					? 'chatscreen'
					: 'homescreen',
			selectedColor: '',
			showFeedbackPopup: false,
			thumbFilledUp: null,
			thumbFilledDown: null,
			messageId: 0,
			enableVoiceModal: false,
			voiceText: '',
		};
	};

	removeCart = (id) => {
		Axios.post(
			window['BASE_URL'] + '/shop/product/cart/removeItemsFromCart',
			{ data: `${id}` },
			{
				headers: {
					'x-tenant-id': this.props.tenantID,
					Authorization: `Bearer ${this.state.bearerToken}`,
				},
			}
		);
	};
	clearSessionStorageData = () => {
		const keysToRemove = [];

		for (let i = 0; i < sessionStorage.length; i++) {
			const key = sessionStorage.key(i);
			if (key.startsWith('FF-')) {
				keysToRemove.push(key);
			}
		}

		keysToRemove.forEach((key) => sessionStorage.removeItem(key));
	};

	updateCart = (quantity) => {
		this.addUserResponse(quantity, Date.now());
		if (parseInt(quantity) == 0) {
			return this.addServerResponse({
				responseElements: [
					{
						displayResponse: 'Please enter the valid quantity',
						responseType: 'SIMPLE',
					},
				],

				errorFallbackLinks: this.state.data.quickLinksOnError,
				timeStamp: Date.now() + new Date().getTimezoneOffset() * 60 * 1000,
			});
		}
		if (parseInt(quantity) == 0) {
			return this.addServerResponse({
				responseElements: [
					{
						displayResponse: 'Please enter the valid quantity',
						responseType: 'SIMPLE',
					},
				],

				errorFallbackLinks: this.state.data.quickLinksOnError,
				timeStamp: Date.now() + new Date().getTimezoneOffset() * 60 * 1000,
			});
		}
		Axios.post(
			window['BASE_URL'] + '/shop/product/cart/updateQuantity',
			{ data: `${this.state.variantId}$$@$$${quantity}` },
			{
				headers: {
					'x-tenant-id': this.props.tenantID,
					Authorization: `Bearer ${this.state.bearerToken}`,
				},
			}
		).then((resp: any) => {
			let response = resp.data.response;
			response = JSON.stringify(response);
			this.setState({
				cartActions: '',
			});
			this.addServerResponse({
				responseElements: [
					{ displayResponse: response, responseType: 'SIMPLE' },
				],

				errorFallbackLinks: this.state.data.quickLinksOnError,
				timeStamp: Date.now() + new Date().getTimezoneOffset() * 60 * 1000,
			});
		});
	};
	getCartId = (id) => {
		this.setState({
			cartId: id,
		});
	};
	handlePaymentStatus = (url) => {
		window.open(url);
		this.clearPaymentInterval();
		setTimeout(() => {
			window.clearInterval(this.clearPaymentInterval);
		}, 70000);
	};
	enableVoice = () => {
		this.setState({
			enableVoiceModal: true,
		});
	};
	openThumbsPopup = (val, up, id) => {
		this.setState({
			messageFeedbackComment: val,
			thumbFilledUp: up,
			messageId: id,
			isModalVisible: val,
		});
	};
	makePayment = () => {
		Axios.post(
			window['BASE_URL'] + '/shop/product/checkout/create',
			{ cartId: this.state.cartId },
			{
				headers: {
					'x-tenant-id': this.props.tenantID,
					Authorization: `Bearer ${this.state.bearerToken}`,
					//"authorization": "Basic VTJGc2RHVmtYMStiZGswVUZLd21WTFlRUHdlZHJqMVZ0bmp3eXJkOXBkdXVPOGNuaUx6cDBBRExjeU9WdnR4dDpVMkZzZEdWa1gxK3RrUFZ2WWtaV2ZKU2VZaTRXbGY5VWdKTWZ4dXdVdkxJPQ=="
				},
			}
		).then((resp: any) => {
			let url = resp.data.response.data.data.cart.checkoutUrl;
			//let HTML={"Click"+<a href={url}>here</a>+" to make a payment"}
			this.setState({
				paymentId: resp.data.response.data.uniqueId,
			});
			this.addServerResponse({
				responseElements: [
					{ displayResponse: 'PAYMENTURL' + url, responseType: 'SIMPLE' },
				],

				errorFallbackLinks: this.state.data.quickLinksOnError,
				timeStamp: Date.now() + new Date().getTimezoneOffset() * 60 * 1000,
			});
		});
	};
	hideMonacoCart = () => {
		this.setState({
			cartExist: false,
		});
	};
	createCart = (variantId, quantity, serviceType, productId) => {
		let url;
		let payload;
		if (this.state.cartExist) {
			url = `/shop/${this.props.tenantID}/cart`;
			payload = {
				conversationId: this.state.conversationalId,
				productId: productId,
				variantId: variantId,
				quantity: quantity,
				cartId: this.state.cartId,
			};

			Axios.put(window['BASE_URL'] + url, payload, {
				headers: {
					'x-tenant-id': this.props.tenantID,
					Authorization: `Bearer ${this.state.bearerToken}`,
				},
			}).then((resp: any) => {
				let response = resp.data.response;
				response = JSON.stringify(response);

				// this.addServerResponse({
				// 	responseElements: [
				// 		{ displayResponse: response, responseType: 'SIMPLE' },
				// 	],

				// 	errorFallbackLinks: this.state.data.quickLinksOnError,
				// 	timeStamp: Date.now() + new Date().getTimezoneOffset() * 60 * 1000,
				// });
			});
		} else {
			url = `/shop/${this.props.tenantID}/cart`;
			payload = {
				conversationId: this.state.conversationalId,
				productId: productId,
				variantId: variantId,
				quantity: quantity,
				country: this.state.currentCountry,
			};

			Axios.post(window['BASE_URL'] + url, payload, {
				headers: {
					'x-tenant-id': this.props.tenantID,
					Authorization: `Bearer ${this.state.bearerToken}`,
				},
			})
				.then((resp: any) => {
					let response = resp.data.response;
					response = JSON.stringify(response);
					let cartId = response && JSON.parse(response).data.cartId;
					this.setState({
						cartExist: true,
						cartId: cartId,
					});

					// this.addServerResponse({
					// 	responseElements: [
					// 		{ displayResponse: response, responseType: 'SIMPLE' },
					// 	],

					// 	errorFallbackLinks: this.state.data.quickLinksOnError,
					// 	timeStamp: Date.now() + new Date().getTimezoneOffset() * 60 * 1000,
					// });
				})
				.catch((error) => {
					if (
						error.response &&
						error.response.data &&
						error.response.data.message
					) {
						this.addServerResponse({
							responseElements: [
								{
									displayResponse: error.response.data.message,
									responseType: 'SIMPLE',
								},
							],

							errorFallbackLinks: this.state.data.quickLinksOnError,
							timeStamp:
								Date.now() + new Date().getTimezoneOffset() * 60 * 1000,
						});
					}
				});
		}
	};
	modifyCart = (data) => {
		Axios.post(
			window['BASE_URL'] + '/shop/product/cart/updateQuantity',
			{
				data: data,
			},
			{
				headers: {
					'x-tenant-id': this.props.tenantID,
					Authorization: `Bearer ${this.state.bearerToken}`,
				},
			}
		).then((resp: any) => {
			let response = resp.data.response;
			response = JSON.stringify(response);
			this.addServerResponse({
				responseElements: [
					{ displayResponse: response, responseType: 'SIMPLE' },
				],

				errorFallbackLinks: this.state.data.quickLinksOnError,
				timeStamp: Date.now() + new Date().getTimezoneOffset() * 60 * 1000,
			});
		});
	};
	getProductDetails = (productId, name) => {
		this.addUserResponse(name, Date.now());
		Axios.get(
			`${window['BASE_URL']}/shop/product/getDetails?productId=${productId}`,
			{
				headers: {
					'x-tenant-id': this.props.tenantID,
					Authorization: `Bearer ${this.state.bearerToken}`,
				},
			}
		).then((resp: any) => {
			let response = resp.data.response;
			response = JSON.stringify(response);
			this.addServerResponse({
				responseElements: [
					{ displayResponse: response, responseType: 'SIMPLE' },
				],

				errorFallbackLinks: this.state.data.quickLinksOnError,
				timeStamp: Date.now() + new Date().getTimezoneOffset() * 60 * 1000,
			});
		});
	};
	getDynamicWelcomeMessage = (data: any) => {
		let botMessage = '';
		let current = new Date();
		let hours = current.getHours();
		let mins = current.getMinutes();
		let totalmins = hours * 60 + mins;

		const langCode =
			this.state && this.state.currentLanguageCode
				? this.state.currentLanguageCode
				: this.props.data.defaultLanguage
				? this.props.data.defaultLanguage
				: 'en';

		const dm = JSON.parse(data);
		for (let i = 0; i < dm.length; i++) {
			if (getMinutesFromHHMM(dm[i].from) < getMinutesFromHHMM(dm[i].to)) {
				if (
					getMinutesFromHHMM(dm[i].from) < totalmins &&
					getMinutesFromHHMM(dm[i].to) >= totalmins
				) {
					botMessage = getLabelTranslation(dm[i], langCode, 'message');
				}
			} else if (
				getMinutesFromHHMM(dm[i].from) === getMinutesFromHHMM(dm[i].to)
			) {
				botMessage = getLabelTranslation(dm[i], langCode, 'message');
			} else {
				if (
					(getMinutesFromHHMM(dm[i].from) < totalmins &&
						getMinutesFromHHMM(dm[i].to) <= totalmins) ||
					(getMinutesFromHHMM(dm[i].from) > totalmins &&
						getMinutesFromHHMM(dm[i].to) >= totalmins)
				) {
					botMessage = getLabelTranslation(dm[i], langCode, 'message');
				}
			}
		}

		return botMessage;
	};

	getLoader = (isLoader: boolean) => {
		this.setState({
			isModalVisible: isLoader,
			showLoader: isLoader,
		});
	};
	setLangListVisibility = (visibility: boolean) => {
		this.setState({
			isLanguageListVisible: visibility,
			predSearchToggle: false,
			predSearchResponse: { search: [] },
		});
	};

	/* Setting logout message for triggering logout node*/
	setLogoutMessage = (message) => {
		this.setState({
			logoutMessage: message,
		});
	};

	redirectToExternalBot = () => {
		window.open(
			`/chatsdk.html?botID=` + encodeURIComponent(this.state.data.eB)
		);
	};

	checkIfRedDotNeeded() {
		if (
			this.state.notifications.length < 0 ||
			this.state.polls.length < 0 ||
			this.state.surveys.length < 0
		) {
			this.setState({
				toShowRedDot: false,
			});
		}
	}

	getAllNotifications = () => {
		DataAPI()
			.post('/GetNotification', {})
			.then((response) => {
				this.setState({ notifications: response.data });
				this.checkIfRedDotNeeded();
			})
			.catch((error) => {
				console.log(error);
			});
	};

	closeNotification(notifId, userId) {
		DataAPI()
			.post('/DeleteNotification', {
				userId: userId,
				notificationId: notifId.toString(),
			})
			.then((response) => {
				if (response.data.response === 'Success') {
					this.getAllNotifications();
				}
			})
			.catch((error) => {
				console.log(error);
			});
	}

	getAllPolls = () => {
		DataAPI()
			.post('/GetPolls', {})
			.then((response) => {
				this.setState({ polls: response.data });
				this.checkIfRedDotNeeded();
			})
			.catch((error) => {
				console.log(error);
			});
	};

	pollSubmit(pollID, userID, pollSelected) {
		DataAPI()
			.post('/DeletePolls', {
				userId: userID,
				pollId: pollID.toString(),
				pollOptionsId: pollSelected,
			})
			.then((response) => {
				if (response.data.response === 'Success') {
					this.getAllPolls();
					let msg = TString({
						labelName: 'ThanksResponse',
						langCode: this.state.currentLanguageCode,
						fromClass: true,
					});
					this.popUpSnackBar(msg);
				}
			})
			.catch((error) => {
				console.log(error);
			});
	}

	getAllSurveys() {
		DataAPI()
			.post('/GetSurvey', {})
			.then((response) => {
				this.setState({
					surveys: response.data,
				});
				this.checkIfRedDotNeeded();
			})
			.catch((error) => {
				console.log(error);
			});
	}

	surveySubmit(id, userid, response) {
		DataAPI()
			.post('/DeleteSurvey', {
				userId: userid,
				surveyId: id.toString(),
				surveyResponse: response,
			})
			.then((response) => {
				if (response.data.response === 'Success') {
					this.getAllSurveys();
					let msg = TString({
						labelName: 'ThanksResponse',
						langCode: this.state.currentLanguageCode,
						fromClass: true,
					});
					this.popUpSnackBar(msg);
				}
			})
			.catch((error) => {
				console.log(error);
			});
	}
	freshChatSocketheartbeat() {
		if (!this.freshChatSocket) return;
		if (this.freshChatSocket.readyState !== 1) return;
		this.freshChatSocket.send(JSON.stringify({ heartbeat: 'heartbeat' }));
		setTimeout(() => {
			this.freshChatSocketheartbeat();
		}, 10000);
	}
	handlefreshChatAgent() {
		if (this.state.freshChatSocketStatus === false) {
			this.freshChatSocket = new WebSocket(
				socketName +
					'://' +
					window['CHAT_URL'] +
					this.state.redirectURL +
					'?id=' +
					this.state.conversationalId +
					'&tenantId=' +
					this.props.tenantID +
					'&botId=' +
					this.props.botID
			);
			this.setState({
				freshChatSocketStatus: true,
			});
			this.freshChatSocket.onopen = () => {
				saveStateSession('isfreshChatSocket', 'opened');
				this.freshChatSocketheartbeat();
			};
		}
		// this.freshChatSocket.onclose = (ev: any) => {
		// 	console.log(ev);
		// 	if (
		// 		ev.reason !== 'freshChat Socket closing from UI' &&
		// 		freshChatSocketOpenCount <= 5
		// 	) {
		// 		//open socket
		// 		this.freshChatSocket = new WebSocket(
		// 			socketName + '://' + window['CHAT_URL'] +
		// 			this.state.redirectURL +
		// 			'?id=' + this.state.conversationalId + '&tenantId=' + this.props.tenantID + '&botId=' + this.props.botID
		// 		);
		// 		freshChatSocketOpenCount++;
		// 	}
		// };
		if (this.freshChatSocket) {
			this.freshChatSocket.onmessage = (event) => {
				const data = JSON.parse(event.data);
				console.log(data);
				if (data) {
					this.fresChatServerResponse(data);
				}
			};
		}
	}
	fresChatServerResponse(res) {
		if (res.agentChat) {
			if (res.eventType === 'conversation_assignment') {
				this.addServerResponseShorthand(
					`You are now connected with an Agent`,
					'info'
				);
			} else {
				this.addServerResponseShorthand(
					res.message,
					'server',
					true,
					res.messageId
				);
			}
		} else {
			if (res.eventType === 'conversation_resolution') {
				this.addServerResponseShorthand(`Agent disconnected the chat`, 'info');
				if (
					this.freshChatSocket &&
					this.freshChatSocket.readyState === WebSocket.OPEN
				) {
					this.freshChatSocket.close(1000, 'freshChat Socket closing from UI');
				}
				this.setState({
					freshChatSocketStatus: false,
					redirectURL: '',
					showcancelMessage: '',
				});
			} else {
				if (res.waitOptions && res.waitOptions.length > 0) {
					let wait_options = [];
					res.waitOptions.map((item, index) => {
						if (item.toLowerCase() === 'cancel') {
							this.setState({
								showcancelMessage: item + '$$$' + res.cancelMessage,
							});
						}
						return wait_options.push({
							actionText: item,
							displayText: item,
							title: item,
						});
					});

					this.addServerResponse({
						responseElements: [
							{
								displayResponse: res.message,
								responseType: 'MULTICHOICE',
								lists: { items: wait_options },
								listResponseType: 'MULTICHOICE',
								type: 'QUICKLINKS',
								// messageId: response.messageId
							},
						],

						errorFallbackLinks: this.state.data.quickLinksOnError,
						timeStamp: Date.now() + new Date().getTimezoneOffset() * 60 * 1000,
						// messageId: response.messageId
					});
				} else {
					this.addServerResponseShorthand(
						res.message,
						'server',
						true,
						res.messageId
					);
				}
			}
		}
	}

	handleHybridChatAgent() {
		if (
			this.LivechatSocket &&
			this.LivechatSocket.readyState === WebSocket.OPEN
		) {
			this.LivechatSocket.close(1000, 'LiveChat Socket closing from UI');
		}
		this.LivechatSocket = new WebSocket(
			socketName +
				'://' +
				window['CHAT_URL'] +
				this.state.redirectURL +
				'?id=' +
				this.state.conversationalId +
				'&tenantId=' +
				this.props.tenantID +
				'&botId=' +
				this.props.botID +
				'&source=Customer'
		);
		this.LivechatSocket.onopen = () => {
			this.liveChatSocketheartbeat();
		};
		if (this.LivechatSocket) {
			this.LivechatSocket.onmessage = (event) => {
				const data = JSON.parse(event.data);

				if (Object.keys(data)[0] !== 'pong') {
					this.hybridChatServerResponse(data);
				}
			};
		}
		this.LivechatSocket.onclose = (event) => {
			console.log(event);
			if (
				this.LivechatSocket &&
				this.LivechatSocket.readyState === WebSocket.OPEN
			) {
				this.LivechatSocket.close(1000, 'LiveChat Socket closing from UI');
			}
			// this.addServerResponseShorthand(
			// 	`Your chat with the human expert has ended`,
			// 	'info',
			// 	true
			// );
			if (event.reason !== 'LiveChat Socket closing from UI') {
				this.setState({
					freshChatSocketStatus: false,
					redirectURL: '',
				});
			}
		};
	}
	hybridChatServerResponse(res) {
		if (res.eventType === 'Agent_Disconnected') {
			this.addServerResponseShorthand(
				`Your chat with the human expert has ended`,
				'info',
				true
			);
			if (
				this.LivechatSocket &&
				this.LivechatSocket.readyState === WebSocket.OPEN
			) {
				this.LivechatSocket.close(1000, 'LiveChat Socket closing from UI');
			}
			this.setState({
				freshChatSocketStatus: false,
				redirectURL: '',
			});
		} else if (res.eventType === 'Conversation_Assigned') {
			this.addServerResponseShorthand(
				`You are now connected with a human expert`,
				'info',
				true
			);
		} else if (res.eventType === 'Customer_Disconnected') {
			this.addServerResponseShorthand(
				`Your chat with the human expert has ended`,
				'info',
				true
			);
			if (
				this.LivechatSocket &&
				this.LivechatSocket.readyState === WebSocket.OPEN
			) {
				this.LivechatSocket.close(1000, 'LiveChat Socket closing from UI');
			}
			this.setState({
				freshChatSocketStatus: false,
				redirectURL: '',
			});
		}
		if (res.suggestions && res.suggestions.length > 0) {
			let suggestions_options = [];
			res.suggestions.map((item, index) => {
				// if (item.toLowerCase() === 'cancel') {
				// 	this.setState({
				// 		showcancelMessage: item + '$$$' + res.cancelMessage,
				// 	});
				// }
				return suggestions_options.push({
					actionText: item,
					displayText: item,
					title: item,
				});
			});

			this.addServerResponse({
				responseElements: [
					{
						displayResponse: res.message,
						responseType: 'MULTICHOICE',
						lists: { items: suggestions_options },
						listResponseType: 'MULTICHOICE',
						type: 'QUICKLINKS',
						// messageId: response.messageId
					},
				],

				errorFallbackLinks: this.state.data.quickLinksOnError,
				timeStamp: Date.now() + new Date().getTimezoneOffset() * 60 * 1000,
				// messageId: response.messageId
			});
		} else {
			this.addServerResponseShorthand(
				res.message,
				'server',
				true,
				res.messageId
			);
		}
		this._scrollToBottom(true);
	}

	liveChatSocketheartbeat() {
		if (!this.LivechatSocket) return;
		if (this.LivechatSocket.readyState !== 1) return;
		this.LivechatSocket.send(JSON.stringify({ ping: 'ping' }));
		setTimeout(() => {
			this.liveChatSocketheartbeat();
		}, 5000);
	}

	assignPredSearchQues = (ev) => {
		this.handleSubmit(ev, {});
		this.hidePredSearch();
	};

	toggleOverlay() {
		this.setState({ disableDotOnceClick: false });
		this.setState((prevState) => {
			return { isOverlayVisible: !prevState.isOverlayVisible };
		});
	}

	toggleChatBody() {
		this.setState((prevState) => {
			return {
				isChatBodyVisible: !prevState.isChatBodyVisible,
				isOverlayVisible: false,
				predSearchToggle: false,
			};
		});
		this.stopSpeaking();
	}

	triggerLogout() {
		this.handleSubmit(this.state.logoutMessage || 'logout', {});
	}

	toggleSpeakingFunctionality = (val: boolean) => {
		/**
		 * speakingEnabled flag controls the conversion of text to speech.
		 * Setting this to false will ensure the prepareAudioData and subsequent functions are not called.
		 * This is different from stopSpeaking method in a way that stopSpeaking controls speech audio output
		 * for already generated audio, whereas this flag disallows the conversion from text to speech.
		 */
		this.setState({
			speakingEnabled: val,
		});
	};
	RefreshSession() {
		this.setState({
			chatMessages: [
				{
					message: [
						{
							displayResponse: this.state.welcomeMessage,
							responseType: 'SIMPLE',
						},
					],
					timeStamp: TimeUtil.getCurrentTime(new Date()),
					key: null,
					messageType: 'server',
					customInfos: {},
					suggestionChips: [],
				},
			],
			conversationalId: 0,
		});
	}
	restartFlow() {
		this.clearSession(
			{
				isBotVisible: true,
				isLanguageListVisible: false,
				currentLanguageCode: this.props.data.defaultLanguage,
			},
			() => {
				if (
					this.state.data.notification === 'true' &&
					!this.props.data.flyFishChangesReq
				) {
					this.getAllNotifications();
					this.getAllPolls();
					this.getAllSurveys();
				}
				if (
					this.state.data.campaignWorkflowQuestion &&
					this.state.data.isInsideCampaign
				) {
					this.handleSubmit(
						this.state.data.campaignWorkflowQuestion,
						{},
						{ isHidden: true }
					);
				}
			}
		);
	}

	stopSpeaking = () => {
		// stop the speaking for already loaded audio
		this.audioArray.forEach((eachAudioReference) => {
			try {
				eachAudioReference.pause();
			} catch (e) {
				console.log(e);
			}
		});

		this.audioArray = [];
	};
	chatInputhandleSubmit;

	hidePredSearch() {
		this.setState({
			predSearchToggle: false,
		});
	}

	handleInput = (val) => {
		saveStateSession('userResp', val);
		this.setState({ chatInput: val }, () => {
			this.removeLoader();
			if (this.state.isAutoSuggest) {
				this.handleAutoSuggest();
			}
		});
	};
	callAutoSuggestApi = () => {
		if (this.state.chatInput.length === 0) return;
		let reqOptions = {};
		let apiURL = this.state.autoSuggestApiDetails.apiURL;
		const apiPayload = this.state.autoSuggestApiDetails.apiPayload;

		switch (this.state.autoSuggestApiDetails.methodType) {
			case 'get':
			case 'GET': {
				reqOptions = {
					method: 'GET',
				};
				let queryString = '';
				const keys = Object.keys(apiPayload);
				for (let i = 0; i < keys.length; i += 1) {
					queryString += `${keys[i]}=${apiPayload[keys[i]]}&`;
				}
				queryString += `q=${this.state.chatInput}`;
				apiURL += `?${queryString}`;
				break;
			}
			case 'post':
			case 'POST': {
				const body = JSON.stringify({ ...apiPayload, q: this.state.chatInput });
				reqOptions = {
					method: 'POST',
					body,
				};
			}
		}
		const headers = this.state.autoSuggestApiDetails.apiHeader;
		reqOptions = {
			...reqOptions,
			headers,
		};

		fetch(apiURL, reqOptions)
			.then((data) => data.json())
			.then((suggestions) =>
				this.setState({
					suggestions,
				})
			);
	};

	handleAutoSuggest() {
		debounce2(this.callAutoSuggestApi, 500);
	}

	handleFocus() {
		// if (!this.state.isChatBodyVisible)
		// this.setState({ isChatBodyVisible: true });
	}

	handlePredSearch = (ev) => {
		if (
			this.state.data.predictiveSearch === 'true' &&
			(ev.target || ev.nativeEvent)
		) {
			var searchQuery = ev.target.textContent
				? ev.target.textContent
				: ev.nativeEvent.data
				? ev.nativeEvent.data
				: null;
			if (searchQuery && searchQuery.length <= 0) {
				this.hidePredSearch();
			}
			if (ev.keyCode == 27) {
				this.setState({
					predSearchToggle: false,
				});
			}
			let inputType = [
				'insertText',
				'insertCompositionText',
				'insertFromPaste',
				'deleteContentBackward',
			];
			let lasttype = searchQuery
				? searchQuery.charAt(searchQuery.length - 1)
				: null;
			const isQuery =
				(searchQuery && searchQuery.trim().length == 0) ||
				(lasttype && lasttype.trim().length == 0);
			if (
				isQuery ||
				(ev.nativeEvent &&
					isQuery &&
					inputType.includes(ev.nativeEvent.inputType))
			) {
				Axios.get(
					window['BASE_URL'] +
						'/PredictiveSearch/api?mode=autosuggest&q=' +
						encodeURIComponent(searchQuery) +
						'&botid=' +
						this.state.data.botId +
						'&lang=' +
						this.state.currentLanguageCode +
						'&version='
				)
					.then((response) => {
						if (
							typeof response.data == 'object' &&
							response.data.search.length > 0
						) {
							this.setState({
								predSearchToggle: this.state.chatInput.length > 0,
								predSearchResponse: response.data,
							});
						}
					})
					.catch((error) => {
						console.log(error);
					});
			}
		}
	};

	handleKeyUp(ev) {
		if (ev.keyCode == 13) {
			let chatInputElement = document.getElementById('chatInput');
			if (chatInputElement) {
				chatInputElement.innerText = '';
			}
			let options;
			// Validate autosuggest before submitting
			if (this.state.isAutoSuggest) {
				if (
					this.state.suggestions.response
						.map((e) => e.value.toUpperCase())
						.includes(this.state.chatInput.toUpperCase())
				)
					options = {
						isValidated: true,
					};
				else
					options = {
						isValidated: false,
					};
			}
			let chatInputState = this.state.chatInput;
			if (
				chatInputState.length >= 1 &&
				chatInputState.replace(/\s/g, '').length > 0
			) {
				this.handleSubmit(this.state.chatInput, options);
			}
			this.hidePredSearch();
		} else {
			debounce(this.handlePredSearch(ev), 300);
		}
		/**
		 * Check whether input came from mic
		 */
		this.micUsed = ev.mic;
	}
	// checkTimer() {
	// 	document.addEventListener('sessionexpire', this.expiryListener);
	// }

	expiryListener = () => {
		if (this.state.chatMessages.length <= 1) {
			if (Timer.hasStarted) {
				Timer.restart();
			} else {
				Timer.start(15, 'min');
			}
			return;
		}
		this.setState(
			{
				hasSessionExpired: true,
			},
			() => {
				const promise = new Promise((resolve, reject) => {
					if (this.state.wsendpointSocketStatus !== 'closed') {
						this.chatSocket && this.chatSocket.close();
						setTimeout(() => {
							if (this.state.wsendpointSocketStatus !== 'open') {
								resolve('success');
							}
						}, 1000);
					} else {
						resolve('success');
					}
				}).then((res) => {
					if (res === 'success') {
						// DataAPI()
						// 	.post(`/GenericChatBot/clearSession`, {
						// 		logout: true,
						// 		// apiuser:this.state.apiuserValue,
						// 		//  apiuser: loadStateSession("sf-uniqueId"),
						// 	})
						// 	.then((response) => {
						// 		// console.log(response);
						// 	})
						// 	.catch((error) => {
						// 		console.log(error);
						// 	});
						this.clearSession();
					}
				});
			}
		);
	};
	activeSessionInterval = () => {
		this.activeSessionInterval = window.setInterval(
			() => {
				this.restartSession();
			},
			//10000)
			3000000
		); //50mins
	};

	clearPaymentInterval = () => {
		this.clearPaymentInterval = window.setInterval(() => {
			Axios.get(
				window['BASE_URL'] +
					'/shop/ecom/order/web/webhooks?sessionId=' +
					this.state.paymentId,
				{
					headers: {
						'x-tenant-id': this.props.tenantID,
						Authorization: `Bearer ${this.state.bearerToken}`,
						//"authorization": "Basic VTJGc2RHVmtYMStiZGswVUZLd21WTFlRUHdlZHJqMVZ0bmp3eXJkOXBkdXVPOGNuaUx6cDBBRExjeU9WdnR4dDpVMkZzZEdWa1gxK3RrUFZ2WWtaV2ZKU2VZaTRXbGY5VWdKTWZ4dXdVdkxJPQ=="
					},
				}
			).then((response: any) => {
				if (this.state.paymentStatus.length == 0) {
					this.addServerResponse({
						responseElements: [
							{ displayResponse: 'PAYMENTSTATUS', responseType: 'SIMPLE' },
						],

						errorFallbackLinks: this.state.data.quickLinksOnError,
						timeStamp: Date.now() + new Date().getTimezoneOffset() * 60 * 1000,
					});
				}
				this.setState(
					{
						paymentStatus: response.data.message,
					},
					() => {
						if (
							this.state.paymentStatus
								.toLowerCase()
								.indexOf('thank you for your order') > -1
						) {
							window.clearInterval(this.clearPaymentInterval);
						}
					}
				);
			});
		}, 10000);
	};

	clearSessionInterval() {
		clearInterval(window.setSessionInterval);

		// clearInterval(window.setCustAliveInterval);
	}

	// clearSessionApi(resolve?: any) {

	// 	fetch(`${window['BASE_URL']}/HybridChat/clearSessionInHybrid`, {
	// 		credentials: 'include',
	// 		method: 'POST',
	// 		headers: {
	// 			'Content-Type': 'application/json',
	// 		},
	// 		body: JSON.stringify({
	// 			botid: this.props.botID.toString(),
	// 			// botID: this.props.data.eB, //"k8aTRpmKSwddYR8m4uvZBg==",
	// 			// botid: decodeURIComponent(this.props.data.eB), //"k8aTRpmKSwddYR8m4uvZBg=="),
	// 			// version: 'prod',
	// 			SF_BASE_URL: `${window['BASE_URL']}`,
	// 			// SF_CHAT_URL: 'https://dev.flyfish.ai',
	// 			apiuser: loadStateSession('sf-uniqueId'),
	// 		}),
	// 	})
	// 		.then((data) => data.json())
	// 		.then((response) => {
	// 			Timer.start(15, 'min');
	// 			resolve && resolve('Success');
	// 			this.setState(this.setInitialState());
	// 			// this.setState({
	// 			//   apiuserValue:""
	// 			// })
	// 			sessionStorage.removeItem(this.state.data.eB);
	// 			sessionStorage.removeItem('sf-uniqueId');
	// 			this.clearSessionInterval();
	// 		});
	// }

	// handleMessageFromAgentDashboard = (event) => {
	// 	if (event.data && event.data.chat) {
	// 		/**
	// 		 * Clear existing Messages
	// 		 */
	// 		this.setState({ chatMessages: [], showThumbs: false }, () => {
	// 			// console.log(event.data);
	// 			for (let i = 0; i < event.data.chat.length; i += 1) {
	// 				const eachResponse = event.data.chat[i];
	// 				const msg = eachResponse.message;
	// 				// .replace(/:/g, ": ")
	// 				// .replace(/<(?!br)([^>]+)>/g, "");
	// 				const disamb = eachResponse.disambQuestions;
	// 				const isMedia = eachResponse.isMedia || false;
	// 				const mediaMeta = eachResponse.mediaMeta || {};
	// 				const showdate = eachResponse.date;
	// 				const suggestions = eachResponse.suggestions; //added
	// 				if (
	// 					eachResponse.source === MessageSource.user &&
	// 					eachResponse.auxAction === AuxiliaryActions.typing
	// 				) {
	// 					this.removeLoader();
	// 					this.appendLoader({ appengToRight: true });
	// 				} else {
	// 					if (eachResponse.auxAction !== AuxiliaryActions.typing) {
	// 						this.removeLoader();
	// 					}
	// 					if (!msg) {
	// 						continue;
	// 					} else {
	// 						this.removeLoader();

	// 						if (
	// 							msg === BanglaSocketMessages.Connected ||
	// 							msg === BanglaSocketMessages.UserLeft ||
	// 							msg === BanglaSocketMessages.ChatTasfered ||
	// 							msg === SocketMessages.AgentChatReleased ||
	// 							msg.indexOf(SocketMessages.AgentWhatsapChatTasfered) > -1 ||
	// 							msg === SocketMessages.AgentTakeOver ||
	// 							msg.indexOf(SocketMessages.AgentStartChat) > -1 ||
	// 							msg === SocketMessages.AgentEndChat ||
	// 							msg === SocketMessages.AgentLogout ||
	// 							msg === SocketMessages.AgentDisconnected
	// 						) {
	// 							this.addServerResponseShorthand(
	// 								msg,
	// 								'info',
	// 								true,
	// 								isMedia,
	// 								mediaMeta,
	// 								disamb,
	// 								showdate,
	// 								suggestions //added
	// 							);
	// 						} else if (eachResponse.source === MessageSource.user) {
	// 							this.addUserResponse(
	// 								msg,
	// 								new Date(eachResponse.time).getTime(),
	// 								isMedia,
	// 								mediaMeta,
	// 								showdate
	// 							);
	// 						} else if (
	// 							eachResponse.source === MessageSource.agent ||
	// 							eachResponse.source === MessageSource.bot
	// 						) {
	// 							this.addServerResponseShorthand(
	// 								msg,
	// 								'server',
	// 								true,
	// 								new Date(eachResponse.time).getTime(),
	// 								isMedia,
	// 								mediaMeta,
	// 								disamb,
	// 								showdate,
	// 								suggestions //added
	// 							);
	// 						}
	// 					}
	// 				}
	// 			}
	// 		});
	// 	}
	// };
	checkEmailValidation(email: string) {
		var re = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/; //nosonar
		if (email && re.test(email)) {
			return true;
		} else {
			return false;
		}
	}
	checkNameValidation() {
		var regex = /^[a-zA-Z0-9 ]{2,30}$/; //nosonar
		//  var regex=/^[a-z0-9_\.]+$/;
		var spaceRegex = /\s{5,}/;
		if (
			this.state.userDetailName &&
			regex.test(this.state.userDetailName.trim()) &&
			!spaceRegex.test(this.state.userDetailName.trim())
		) {
			return true;
		} else {
			return false;
		}
	}
	checkPhoneNumberValidation() {
		var regex = /^[1-9][0-9]+$/; //nosonar
		if (
			this.state.userDetailContact &&
			this.state.userDetailContact.length === 10 &&
			regex.test(this.state.userDetailContact.trim())
		) {
			return true;
		} else {
			return false;
		}
	}
	handleUserDetails = () => {
		let checkvalidName = this.state.isUserNameNeeded
			? this.checkNameValidation()
			: true;
		let checkvalidLastName = this.state.isuserLastNameNeeded
			? // ? this.checkEmailValidation(this.state.userDetailLastName)
			  this.checkNameValidation()
			: true;
		let checkPhoneNumber = this.state.isUserContactNeeded
			? this.checkPhoneNumberValidation()
			: true;

		if (
			checkvalidName === false ||
			checkvalidLastName === false ||
			checkPhoneNumber === false
		) {
			if (this.state.isUserContactNeeded) {
				document.getElementById('contactDetails-validation-error').innerHTML =
					'';
			}
			if (this.state.isUserNameNeeded) {
				document.getElementById('firstname-validation-error').innerHTML = '';
			}
			if (this.state.isuserLastNameNeeded) {
				document.getElementById('lastname-validation-error').innerHTML = '';
			}
			if (this.state.isUserNameNeeded) {
				if (this.state.userDetailName === '') {
					document.getElementById('firstname-validation-error').innerHTML =
						"Can't be empty, Please enter a valid first name";
				} else if (
					this.state.userDetailName !== '' &&
					checkvalidName === false
				) {
					document.getElementById('firstname-validation-error').innerHTML =
						'This doesn’t seem like a name, please try again';
				} else if (
					this.state.userDetailName.length < 2 &&
					checkvalidName === false
				) {
					document.getElementById('firstname-validation-error').innerHTML =
						'Please enter the name more than 2 Characters';
				} else {
					document.getElementById('firstname-validation-error').innerHTML = ' ';
				}
			}
			if (this.state.isuserLastNameNeeded) {
				if (this.state.userDetailLastName === '') {
					document.getElementById('lastname-validation-error').innerHTML =
						"Can't be empty, Please enter a valid first name";
				} else if (
					this.state.userDetailLastName !== '' &&
					checkvalidName === false
				) {
					document.getElementById('lastname-validation-error').innerHTML =
						'This doesn’t seem like a name, please try again';
				} else if (
					this.state.userDetailLastName.length < 2 &&
					checkvalidName === false
				) {
					document.getElementById('lastname-validation-error').innerHTML =
						'Please enter the name more than 2 Characters';
				} else {
					document.getElementById('lastname-validation-error').innerHTML = ' ';
				}
			}
			if (this.state.isUserContactNeeded) {
				if (this.state.userDetailContact === '') {
					document.getElementById('contactDetails-validation-error').innerHTML =
						"Can't be empty,Please enter a valid phone number";
				} else if (
					this.state.userDetailContact !== '' &&
					(this.state.userDetailContact.length < 10 ||
						checkPhoneNumber === false)
				) {
					document.getElementById('contactDetails-validation-error').innerHTML =
						'Invalid phone number, Please try again';
				} else {
					document.getElementById('contactDetails-validation-error').innerHTML =
						'';
				}
			}
		} else {
			if (
				checkvalidLastName === true &&
				checkPhoneNumber === true &&
				checkvalidName === true
			) {
				if (this.state.isUserContactNeeded) {
					document.getElementById('contactDetails-validation-error').innerHTML =
						'';
				}
				if (this.state.isUserNameNeeded) {
					document.getElementById('firstname-validation-error').innerHTML = '';
				}
				if (this.state.isuserLastNameNeeded) {
					document.getElementById('lastname-validation-error').innerHTML = '';
				}
				this.setState({
					disableUserDetailBtn: 'clicked',
					collectUserDetails: false,
				});

				const sessionID = this.state.conversationalId;
				const IPaddress = this.state.IPaddress;
				this.setState(
					{
						collectUserDetails: false,
						userDetailName: '',
						userDetailLastName: '',
						userDetailContact: '',
						connectSocketAfterUserDetails: true,
						userDetailsPopup: this.state.userDetailsPopup + 1,
						disableUserDetailBtn: 'open',
					},
					() => {
						this.setUpAgentListener({ sessionID, IPaddress });
					}
				);
				DataAPI()
					.post('/collectUserDetails', {
						name: this.state.userDetailName,
						email_id: this.state.userDetailLastName,
						contact_no: this.state.userDetailContact
							? this.state.SelectedCountryCode + this.state.userDetailContact
							: '',

						apiuser: loadStateSession('sf-uniqueId'),
					})
					.then((response) => {
						const IPaddress: string = response.data.IPaddress;
						const sessionID: string = response.data.sessionId;
						if (response) {
							if (response.data.serverReply) {
								this.addServerResponseShorthand(
									response.data.serverReply,
									'server',
									true
								);
							}

							this.setState(
								{
									collectUserDetails: false,
									userDetailName: '',
									userDetailLastName: '',
									userDetailContact: '',
									connectSocketAfterUserDetails: true,
									userDetailsPopup: this.state.userDetailsPopup + 1,
									disableUserDetailBtn: 'open',
								},
								() => {
									this.setUpAgentListener({ sessionID, IPaddress });
								}
							);
						}
					});
			}
		}
	};
	get sortedCountryCodes() {
		return this.state.countryCodes.sort((a, b) => {
			return a.callingCodes.localeCompare(b.callingCodes, undefined, {
				numeric: true,
				sensitivity: 'base',
			});
		});
	}
	wsAgentInterventionheartbeat() {
		if (!this.takeoverSocket) return;
		if (this.takeoverSocket.readyState !== 1) return;
		this.takeoverSocket.send(JSON.stringify({ keepalive: 'true' }));
		setTimeout(this.wsAgentInterventionheartbeat, 5000);
	}
	decideUserDetailCollection() {
		// DataAPI()
		//   .post("/decideUserDetailCollection", {
		//     botid: this.props.botID,
		//     // apiuser:this.state.apiuserValue,
		//     apiuser: loadStateSession("sf-uniqueId"),
		//   })
		//   .then((response: any) => {
		//     if (response.data.fieldForUserDeatils !== "") {
		//       if (response.data.fieldForUserDeatils.includes("name")) {
		//         this.setState({
		//           isUserNameNeeded: true,
		//         });
		//       }
		//       if (response.data.fieldForUserDeatils.includes("email")) {
		//         this.setState({
		//           isUserEmailNeeded: true,
		//         });
		//       }
		//       if (response.data.fieldForUserDeatils.includes("contact_no")) {
		//         this.setState({
		//           isUserContactNeeded: true,
		//         });
		//       }
		//     }
		this.setState(
			{
				// collectUserDetails: response.data.collectUserDetails,
				collectUserDetails: false,
			},
			() => {
				if (this.state.collectUserDetails === false) {
					const sessionID = this.state.conversationalId;
					const IPaddress = this.state.IPaddress;
					const json: ChatSocketRequest = {
						sessionId: sessionID,
						IPaddress,
						message: loadStateSession('userResp'),
						action: 'user_client',
						channel: 'webs',
						key: 0,
					};
					if (
						this.state.wsendpointSocketStatus === 'closed' ||
						this.state.wsendpointSocketStatus === ''
					) {
						//open socket
						this.chatSocket = new WebSocketClient(
							// 'ws',
							socketName,
							window['CHAT_URL'],
							'/HybridChat/wsServer?apiuser=' + this.state.conversationalId,
							json,
							this.chatSocketCloseListener,
							this.chatSocketListener
						);
						if (this.state.wsendpointSocketStatus !== 'closed') {
							this.chatSocket && this.chatSocket.close();
						}
						if (this.state.wsendpointSocketStatus !== 'closed') {
							this.chatSocket && this.chatSocket.close();
						}
						this.chatSocket.connect();
						this.setState({
							socketValidation: this.state.socketValidation + 1,
							wsendpointSocketStatus: 'open',
							connectSocketAfterUserDetails: true,
						});
					} else {
						this.chatSocket.send(json);
					}
				}
			}
		);

		// Axios.get("https://restcountries.eu/rest/v2/all").then((response) => {
		//   this.setState({
		//     countryCodes: response.data.map((countryData: any) => ({
		//       name: countryData.name,
		//       callingCodes: countryData.callingCodes[0],
		//       flag: countryData.flag,
		//     })),
		//   });
		// });
		// })
		// .catch((error) => {
		//   console.log(error);
		// });
	}
	addServerMessage = (msg, id?) => {
		this.addServerResponse({
			responseElements: [{ displayResponse: msg, responseType: 'SIMPLE' }],
			errorFallbackLinks: this.state.data.quickLinksOnError,
			timeStamp: Date.now() + new Date().getTimezoneOffset() * 60 * 1000,
		});
		if (
			msg.indexOf(
				"I'm happy to help you continue shopping! Can you please provide me with more information on what you are looking for?"
			) > -1
		) {
			this.setState({
				cartExist: true,
			});
		}
		if (
			msg.indexOf(
				"I'm happy to help you continue shopping! Can you please provide me with more information on what you are looking for?"
			) > -1
		) {
			this.setState({
				cartExist: true,
			});
		}
		if (msg.indexOf('Please enter the quantity') > -1) {
			this.setState({
				cartActions: 'modify',
				variantId: id,
			});
		}
		if (msg.indexOf('Item removed from cart') > -1) {
			this.removeCart(id);
		}
	};

	addUserResponse = (
		chatInput: string,
		time: number,
		isMedia?: boolean,
		mediaMeta?: MediaMetaType,
		showdate?: string
	) => {
		this.setState(
			(prevState) => {
				return {
					chatMessages: [
						...prevState.chatMessages,
						{
							message: chatInput,
							timeStamp: TimeUtil.getCurrentTime(new Date(time)),
							messageType: 'user',
							isFeedbackVisible: true,
							key: null,
							customInfos: {},
							suggestionChips: [],
							isMedia,
							mediaMeta,
							showdate,
						},
					],
				};
			},
			() => {
				this._scrollToBottom();
				this.disableActionLinks();
			}
		);
	};
	disableActionLinks = () => {
		let customButtonElements = document.querySelectorAll('.msg-server-outer');
		customButtonElements = Array.prototype.slice.call(customButtonElements);
		let elementLength = customButtonElements.length;
		if (elementLength > 1) {
			customButtonElements.forEach((element, i) => {
				if (i != elementLength - 1) {
					Array.prototype.slice
						.call(element.querySelectorAll('.action-elem'))
						.forEach((actionElem) => {
							actionElem.classList.add('previous-button-disabled');
						});
				}
			});
		}
	};
	SessionKeepAlive() {
		DataAPI()
			.post('/SessionKeepAlive', {
				logout: true,
				isAgent: false,
				// apiuser:this.state.apiuserValue,
				apiuser: this.state.conversationalId,
			})
			.then((response) => {})
			.catch((error) => {
				console.log(error);
			});
	}
	handleSubmitForLiveAgent = (chatInput: string) => {
		const json: ChatSocketRequest = {
			sessionId: this.state.conversationalId,
			IPaddress: this.state.IPaddress,
			message: chatInput,
			action: 'user_client',
			channel: 'webs',
			key: 0,
		};
		this.chatSocket.send(json);
		const apiuser = loadStateSession('sf-uniqueId');

		// this.SessionKeepAlive();

		if (Timer.hasStarted) {
			Timer.restart();
		} else {
			Timer.start(15, 'min');
		}
		this.setState({
			chatInput: '',
		});
		this.addUserResponse(chatInput, Date.now());
	};
	shouldPassThroughSocket = () => {
		return (
			this.state.isDisconnectingFromAgent || this.state.isConnectedWithAgent
		);
	};
	handleLiveChat = (sessionID: string, IPaddress: string, response: any) => {
		// ,triggerEmail:boolean
		// if(triggerEmail===false){
		if (response[0].displayResponse) {
			for (let i = 0; i < response.length; i++) {
				this.addServerResponseShorthand(
					response[i].displayResponse,
					'server',
					true
				);
			}
		}
		// if (response[0].displayResponse) {
		//   //added
		//   this.addServerResponseShorthand(
		//     response[0].displayResponse,
		//     "server",
		//     true
		//   );
		// }
		// }
		// else{
		//   this.emailConfigurationApi();
		// }

		this.startWaitingForAgent();
		this.setUpAgentListener({ IPaddress, sessionID });
	};
	setUpAgentListener = ({ sessionID, IPaddress }) => {
		const json: ChatSocketRequest = {
			sessionId: sessionID,
			IPaddress,
			message: loadStateSession('userResp'),
			action: 'user_client',
			channel: 'webs',
			key: 0,
		};

		this.setState({
			sessionID: sessionID,
			IPaddress,
		});
		if (
			this.state.userDetailsPopup === 0 &&
			this.state.handleUserDetailsPopUponTakeover === false
		) {
			this.decideUserDetailCollection();
		} else if (this.state.connectSocketAfterUserDetails) {
			if (
				this.state.wsendpointSocketStatus === 'closed' ||
				this.state.wsendpointSocketStatus === ''
			) {
				//open socket
				this.chatSocket = new WebSocketClient(
					// 'ws',
					socketName,
					window['CHAT_URL'],
					'/HybridChat/wsServer?apiuser=' + this.state.conversationalId,
					json,
					this.chatSocketCloseListener,
					this.chatSocketListener
				);

				this.chatSocket.connect();
				//added newly

				this.setState({
					socketValidation: this.state.socketValidation + 1,
					wsendpointSocketStatus: 'open',
				});
			} else {
				this.chatSocket.send(json);
			}
		} else if (this.state.handleUserDetailsPopUponTakeover) {
			if (
				this.state.wsendpointSocketStatus === 'closed' ||
				this.state.wsendpointSocketStatus === ''
			) {
				//open socket
				this.chatSocket = new WebSocketClient(
					// 'ws',
					socketName,
					window['CHAT_URL'],
					'/HybridChat/wsServer?apiuser=' +
						//  this.state.apiuserValue,
						this.state.conversationalId,
					json,
					this.chatSocketCloseListener,
					this.chatSocketListener
				);

				this.chatSocket.connect();
				this.setState({
					socketValidation: this.state.socketValidation + 1,
					wsendpointSocketStatus: 'open',
				});
			} else {
				this.chatSocket.send(json);
			}
		} else if (
			this.state.socketValidation === 0 ||
			this.state.collectUserDetails === false
		) {
			if (
				this.state.wsendpointSocketStatus === 'closed' ||
				this.state.wsendpointSocketStatus === ''
			) {
				//open socket
				this.chatSocket = new WebSocketClient(
					// 'ws',
					socketName,
					window['CHAT_URL'],
					'/HybridChat/wsServer?apiuser=' +
						//  this.state.apiuserValue,
						this.state.conversationalId,
					json,
					this.chatSocketCloseListener,
					this.chatSocketListener
				);

				this.chatSocket.connect();
				this.setState({
					socketValidation: this.state.socketValidation + 1,
					wsendpointSocketStatus: 'open',
				});
			} else {
				this.chatSocket.send(json);
			}
		}
	};
	addServerResponseShorthand = (
		msg: string,
		messageType?: string,
		fromLiveAgent?: boolean,
		messageId?: number,
		time?: number,
		isMedia?: boolean,
		mediaMeta?: MediaMetaType,
		disamb?: any,
		showdate?: string,
		suggestions?: any //added
	) => {
		// added
		let storingDisamb = '';

		if (disamb && disamb.length > 0) {
			disamb = JSON.parse(disamb);
			storingDisamb = '</br><div>';
			let disambText = '';

			for (var key in disamb) {
				if (disamb.hasOwnProperty(key)) {
					disambText += `<div class="disamb-action-elem" style={{ 
           pointerEvents: "none", 
          }}>
                           ${disamb[key].displayText}
                       </div>`;
				}
			}
			storingDisamb = disambText + '</div>';
			// console.log(storingDisamb)
		}

		if (suggestions && suggestions.length > 0 && suggestions !== '[]') {
			// console.log('hiii')
			suggestions = JSON.parse(suggestions);
			storingDisamb = '</br><div>';
			let suggestionsText = '';

			for (var key in suggestions) {
				if (suggestions.hasOwnProperty(key)) {
					suggestionsText += `<div class="disamb-action-elem" style={{ 
           pointerEvents: "none", 
          }}>
                           ${suggestions[key].displayText}
                       </div>`;
				}
			}
			storingDisamb = suggestionsText + '</div>';
			// console.log(storingSuggestions)
		}

		this.addServerResponse(
			{
				responseElements: [
					{
						displayResponse: msg + storingDisamb,
						responseType: isMedia ? 'MEDIA' : 'SIMPLE',
						isMedia: isMedia || false,
						mediaMeta: mediaMeta || {},
						showdate: showdate,
						messageId: messageId,
					},
				],
				messageId: messageId,
				errorFallbackLinks: this.props.data.quickLinksOnError,
				timeStamp: time
					? time + new Date().getTimezoneOffset() * 60 * 1000
					: Date.now() + new Date().getTimezoneOffset() * 60 * 1000,
			},
			messageType,
			fromLiveAgent
		);
	};
	chatSocketListener = (event: MessageEvent) => {
		try {
			const data = JSON.parse(event.data);
			if (data.length > 0) {
				const messageFromAgent = data[0];

				switch (messageFromAgent.type) {
					case LiveChatMessageTypes.waiting: {
						this.setState({
							positionInQueue: messageFromAgent.userPosition,
						});
						break;
					}
					case LiveChatMessageTypes.agentInfo: {
						switch (messageFromAgent.action) {
							case AgentActions.joined: {
								this.connectToAgent(
									messageFromAgent.name,
									messageFromAgent.isTakeOver
								);
								break;
							}
							case AgentActions.left: {
								this.setState(
									{
										isWaitingForAgent: false,
									},
									() => {
										this.disconnectFromAgent(true);
										if (messageFromAgent.msg) {
											this.addServerResponseShorthand(
												messageFromAgent.msg,
												'server',
												true,
												messageFromAgent.messageId
											);
										}
									}
								);

								this.setState({
									wsendpointSocketStatus: 'closed',
								});
								break;
							}
							case AgentActions.transferred: {
								this.setState(
									{
										connectSocketAfterUserDetails: true,
									},
									() => {
										this.startWaitingForAgent();
									}
								);
							}
							case AgentActions.released: {
								this.disconnectFromAgent(false, { keepSocketOpen: true });
								this.startWaitingForAgent();
								// this.addServerResponseShorthand(
								//   "Agent transferred the Chat",
								//   "info",
								//   true
								// );
								if (messageFromAgent.msg) {
									//condition added
									this.addServerResponseShorthand(
										messageFromAgent.msg,
										'server',
										true,
										messageFromAgent.messageId
									);
								}

								this.setState({
									wsendpointSocketStatus: 'open',
								});
								break;
							}
						}
						break;
					}
					case LiveChatMessageTypes.msg: {
						switch (messageFromAgent.auxAction) {
							case AuxiliaryActions.typing: {
								this.removeLoader();
								this.appendLoader();
								break;
							}
							default: {
								this.removeLoader();

								if (messageFromAgent.msg) {
									//condition added
									this.addServerResponseShorthand(
										messageFromAgent.msg,
										'server',
										true,
										messageFromAgent.messageId
									);
								}
								// if (Timer.hasStarted) {
								//   Timer.restart();
								// } else {
								//   Timer.start(15, "min");
								// }
							}
						}

						break;
					}
				}
			}
		} catch (err) {
			console.log({ err, data: event.data });
		}
	};
	handleTransferCancel = () => {
		this.setState({
			isCancellingTransfer: false,
			collectUserDetails: false,
			userDetailName: '',
			userDetailLastName: '',
			userDetailContact: '',
		});
		this.chatSocket && this.chatSocket.close();
		setTimeout(() => {
			this.appendLoader();

			// DataAPI()
			// 	.post('/HybridChat/chat', {
			// q: 'cancel transfer when user is in queue',
			// queueId: '6',
			// lang: this.state.currentLanguageCode,

			// source: 'webs',
			// // apiuser:this.state.apiuserValue,
			// apiuser: loadStateSession('sf-uniqueId'),
			// 	})
			// .then((res) => {
			let extraReqObj = {
				// ...extraReqObj,
				fileUpload: {
					uploadedFileDetails: {
						fileName: '',
						fileSize: '0',
					},
					uploadFileStatus: {
						isValidated: false,
						isFileUpload: false,
					},
				},
			};
			let apiname;
			let payload = {
				q: 'cancel transfer when user is in queue',
				queueId: '6',
				lang: this.state.currentLanguageCode,
				version: 'prod',
				botid: this.props.botID,
				SF_BASE_URL: `${window['BASE_URL']}`,
				mode: '',
				source: 'webs',
				apiuser: this.state.conversationalId,
				tenantId: this.props.tenantID,
				...extraReqObj,
			};
			if (
				!this.state.data.isInsideKampsta &&
				this.state.data.agentSupport &&
				this.state.data.agentSupport === 'true'
			) {
				apiname = '/HybridChat/chat';
			} else {
				apiname = loadStateSession('message_api_url') ?? '/messages/';
			}

			fetch('https://' + window['CHAT_URL'] + apiname, {
				//credentials: 'include',
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					'x-tenant-id': this.props.tenantID,
					Authorization: `Bearer ${this.state.bearerToken}`,
				},
				body: JSON.stringify(payload),
			})
				.then((data) => data.json())
				.then((response) => {
					this.addServerResponseShorthand(
						response.responseElements[0].displayResponse,
						'server',
						true
					);
					this.removeLoader();
					this.handleTakeOverFromAgent();
					// this.decideFeedbackCollection();
				})
				.catch((err) => {
					console.log(err);
					this.removeLoader();
				});
		}, 1000);
	};
	handleContinueWaiting = () => {
		this.setState({
			isWaitingForAgent: true,
			isCancellingTransfer: false,
		});
	};
	startWaitingForAgent = () => {
		this.setState({
			isWaitingForAgent: true,
			isCancellingTransfer: false,
		});
	};
	stopWaitingForAgent = () => {
		this.setState({
			isWaitingForAgent: false,
			isCancellingTransfer: true,
		});
	};
	connectToAgent = (agentName: string, isTakeOver: boolean) => {
		var count = 0;
		this.setState({
			isConnectedWithAgent: true,
			isWaitingForAgent: false,
			isCancellingTransfer: false,
			liveAgentName: agentName,
		});
		if (isTakeOver) {
			if (count === 0) {
				this.addServerResponseShorthand(
					// `${agentName} has joined the chat`,
					`Your conversation with Chatbot is taken over by ${agentName}`,
					'info'
				);
				count++;
				this.setState({
					collectUserDetails: false,
					userDetailName: '',
					userDetailLastName: '',
					userDetailContact: '',
				});
			}
		} else {
			if (count === 0) {
				// this.addServerResponseShorthand(`Connected with ${agentName}`, "info");
				this.addServerResponseShorthand(
					`You are now connected with an Agent ${agentName}`,
					'info'
				);
			}
		}
	};
	disconnectFromAgent = (
		disconnectshow?: boolean,
		config?: { keepSocketOpen: boolean }
	) => {
		var dcount = 0;
		this.setState({
			isConnectedWithAgent: false,
			isDisconnectingFromAgent: false,
			// showDisconnectMsg: true, //changed now
		});
		if (this.state.showDisconnectMsg === true) {
			console.log('Customer disconnected from agent');
			this.setState(
				{
					showDisconnectMsg: false,
				},
				() => {
					this.addServerResponseShorthand(
						// `Disconnected from ${this.state.liveAgentName}`,
						`Customer disconnected from agent`,
						'info',
						true
					);
				}
			);
		} else {
			if (
				!this.state.isWaitingForAgent &&
				dcount === 0 &&
				disconnectshow === true
			) {
				this.addServerResponseShorthand(
					// `Disconnected from ${this.state.liveAgentName}`,
					`Agent disconnected the chat`,
					'info',
					true
				);
				dcount++;
			}
		}

		if (config && config.keepSocketOpen) {
			return;
		}

		// this.chatSocket.close();
		// this.chatSocket.close();
		// setTimeout(() => {
		// 	if (this.state.wsendpointSocketStatus === 'closed') {
		// 		// this.decideFeedbackCollection();
		// 		this.handleSubmit('Get feedback', {}, { isHidden: true });
		// 	}
		// }, 2000);
	};
	callwebsocket = () => {
		const json: ChatSocketRequest = {
			sessionId: this.state.conversationalId,
			IPaddress: this.state.IPaddress,
			message: loadStateSession('userResp'),
			action: 'user_client',
			channel: 'webs',
			key: 0,
		};
		//open socket

		this.chatSocket = new WebSocketClient(
			// 'ws',
			socketName,
			window['CHAT_URL'],
			'/HybridChat/wsServer?apiuser=' + this.state.conversationalId,
			json,
			this.chatSocketCloseListener,
			this.chatSocketListener
		);
		if (this.state.wsendpointSocketStatus !== 'closed') {
			this.chatSocket && this.chatSocket.close();
		}
		if (this.state.wsendpointSocketStatus !== 'closed') {
			this.chatSocket && this.chatSocket.close();
		}
		this.chatSocket.connect();
	};
	chatSocketCloseListener = (ev: any) => {
		// this.decideFeedbackCollection();
		console.log('CHAT SOCKET CLOSE LISNTER');
		console.log(ev);

		if (
			ev.reason !== 'websocketendpoint Socket closing from UI' &&
			socketcount <= 5
		) {
			console.log('call again socket');
			this.callwebsocket();
			socketcount++;
		}

		this.setState(
			{
				wsagentinterventionSocket: false,
				wsendpointSocketStatus: 'closed',
				handleUserDetailsPopUponTakeover: false,
			},
			() => {
				// this.handleTakeOverFromAgent;
			}
		);
	};
	detectmob() {
		if (
			navigator.userAgent.match(/Android/i) ||
			navigator.userAgent.match(/webOS/i) ||
			navigator.userAgent.match(/iPhone/i) ||
			navigator.userAgent.match(/iPad/i) ||
			navigator.userAgent.match(/iPod/i) ||
			navigator.userAgent.match(/BlackBerry/i) ||
			navigator.userAgent.match(/Windows Phone/i)
		) {
			return true;
		} else {
			return false;
		}
	}
	agentIntervention(evt: any, userSessionid: string, IPaddress: string) {
		if (this.takeoverSocket) {
			this.takeoverSocket.onmessage = (event) => {
				const val = JSON.parse(event.data);
				if (val.action === 'websocketendpoint is opened') {
					console.log('call API');

					this.takeoverSocket.send(
						JSON.stringify({
							action: 'user_client',
							IPaddress: IPaddress,
							userSessionId: userSessionid,
							agentSessionId: evt,
							openSocket: 'callAPI',
						})
					);
				}
			};
			this.takeoverSocket.onclose = (event) => {
				console.log(event);

				this.setState(
					{
						wsagentinterventionSocket: false,
					}
					// this.handleTakeOverFromAgent
				);
			};
		}
	}
	isSafari() {
		const uas = navigator.userAgent.toLowerCase();
		return uas.indexOf('chrome') === -1 && uas.indexOf('safari') !== -1;
	}
	// getApiuser = () => {
	// 	let apiuser = loadStateSession(this.state.data.eB);
	// 	// let apiuser = loadStateSession('sf-uniqueId');
	// 	if (!this.isValidApiUser(apiuser)) {
	// 		return new Promise((res) => {
	// 			this.getUniqueId().then((resp) => {
	// 				saveStateSession('sf-uniqueId', resp.data.conversationalId);
	// 				let data = {
	// 					sfUniqueId: resp.data.conversationalId,
	// 					time: new Date().getTime(),
	// 				};
	// 				this.setState({
	// 					uniqueId: data,
	// 				});
	// 				saveStateSession(this.state.data.eB, JSON.stringify(data));

	// 				res(JSON.stringify(data));
	// 			});
	// 		});
	// 	}
	// 	return new Promise((res) => res(loadStateSession(this.state.data.eB)));
	// };
	// getUniqueId = () => {
	// 	return Axios.get(
	// 		window['BASE_URL'] + '/GenericChatBot/getUniqueId?time=' + Date.now(),
	// 		{
	// 			withCredentials: true,
	// 		}
	// 	);
	// };
	// checkApiUserToken = () => {
	// 	// const apiuser = loadStateSession(this.state.data.eB);
	// 	const apiuser = loadStateSession('sf-uniqueId');
	// 	if (!this.isValidApiUser(apiuser)) {
	// 		this.getUniqueId().then((resp) => {
	// 			saveStateSession('sf-uniqueId', resp.data.conversationalId);
	// 			let data = {
	// 				sfUniqueId: resp.data.conversationalId,
	// 				time: new Date().getTime(),
	// 			};
	// 			this.setState({
	// 				uniqueId: data,
	// 			});
	// 			saveStateSession(this.state.data.eB, JSON.stringify(data));
	// 		});
	// 	}
	// };

	isValidApiUser = (apiuser) => {
		let totalSessionTimeout =
			Number(this.props.data.apiSessionTimeoutInMins) || 5;
		if (apiuser === null && this.state.uniqueId === null) {
			return false;
		} else if (
			this.state.uniqueId != null &&
			JSON.stringify(this.state.uniqueId) !== apiuser
		) {
			saveStateSession(this.state.data.eB, JSON.stringify(this.state.uniqueId));
			return true;
		} else {
			try {
				let data = JSON.parse(apiuser);
				let currentTime = new Date().getTime();
				let timediff = currentTime - data.time;
				if (
					timediff &&
					(timediff < 0 || timediff > totalSessionTimeout * 60 * 1000)
				) {
					sessionStorage.removeItem(this.state.data.eB);
					return false;
				}
				this.state.uniqueId === null &&
					this.setState({
						uniqueId: data,
					});
				return true;
			} catch {
				return false;
			}
		}
	};

	handleSubmit(chatInput, extraReqObj?, config?, displayMessage?) {
		/**
		 *
		 * Close notification screen, if open
		 */
		window.clearInterval(this.clearPaymentInterval);
		const apiuser = this.state.conversationalId;
		if (this.shouldPassThroughSocket()) {
			this.handleSubmitForLiveAgent(chatInput);
			return;
		}

		if (displayMessage == 'show payment message') {
			this.addUserResponse('Make Payment', Date.now());
			setTimeout(() => {
				this.addServerMessage(
					'The payment is successful, thank you for shopping with us!'
				);
			}, 800);

			return;
		}
		if (this.state.cartActions == 'modify') {
			this.updateCart(chatInput);
			return;
		} else onlySpecialCharactersEntered = false;
		var replaceSpecialcharacter = chatInput;
		if (
			!chatInput.metaData &&
			chatInput.toLowerCase() === 'cancel' &&
			this.state.showcancelMessage.indexOf('Cancel') > -1
		) {
			this.addUserResponse(
				this.state.showcancelMessage.split('$$$')[0],
				Date.now()
			);

			this.addServerResponse({
				responseElements: [
					{
						displayResponse: this.state.showcancelMessage.split('$$$')[1],
						responseType: 'SIMPLE',
					},
				],
				errorFallbackLinks: this.state.data.quickLinksOnError,
				timeStamp: Date.now() + new Date().getTimezoneOffset() * 60 * 1000,
			});
			if (
				this.freshChatSocket &&
				this.freshChatSocket.readyState === WebSocket.OPEN
			) {
				this.freshChatSocket.close(1000, 'freshChat Socket closing from UI');
			}
			this.setState({
				freshChatSocketStatus: false,
				redirectURL: '',
				showcancelMessage: '',
			});
			return;
		}

		if (chatInput.metaData) {
		} else {
			replaceSpecialcharacter = replaceSpecialcharacter.replace(
				/[&\/\\#,+()\s$~%.'":@!^_;|\-\[\]*?<>{}]/g,
				''
			);
		}
		// var pattern = /^[\p{L}\p{M}\p{Zs}\p{N}]{2,30}$/u;
		if (replaceSpecialcharacter.length === 0) {
			onlySpecialCharactersEntered = true;

			this.setState((prevState) => {
				return {
					chatMessages:
						config && config.isHidden
							? [...prevState.chatMessages]
							: [
									...prevState.chatMessages,
									{
										message: displayMessage ? displayMessage : chatInput,
										timeStamp: TimeUtil.getCurrentTime(new Date()),
										messageType: 'user',
										isFeedbackVisible: true,
										key: null,
										customInfos: {},
										suggestionChips: [],
										hidden: config?.isHidden,
									},
							  ],
				};
			});

			var comprhendMessage = TString({
				labelName:
					'sorryIDidnTUnderstandYourMessageShouldHaveAtLeastOneAlphanumericCharacterInItLabel',
				langCode: this.state.currentLanguageCode,
				fromClass: true,
			});

			var data = {
				responseElements: [
					{ displayResponse: comprhendMessage, responseType: 'SIMPLE' },
				],
				errorFallbackLinks: this.state.data.quickLinksOnError,
				searchStatus: 3, // to show quick links
				timeStamp: Date.now() + new Date().getTimezoneOffset() * 60 * 1000,
			};
			this.addServerResponse(data);
			return;
		}

		if (!this.state.isChatBodyVisible) {
			this.toggleChatBody();
		}

		/***
		 *
		 *#TODO : Handle the scroll and toggle based on this (its bit tricky)
		 */
		if (this.state.showWelcomeScreen) {
			this.setState({
				showWelcomeScreen: false,
			});
		}

		/**
		 * Clear suggestions array, if autosuggest was used
		 */
		if (this.state.isAutoSuggest) {
			this.setState({
				isAutoSuggest: false,
				suggestions: {
					response: [],
				},
			});
		}
		this.setState(
			(prevState) => {
				return {
					chatMessages:
						config && config.isHidden
							? [...prevState.chatMessages]
							: [
									...prevState.chatMessages,
									{
										message: chatInput.metaData
											? chatInput
											: chatInput
													// eslint-disable-next-line no-useless-escape
													.replace(/\:/g, ': ')
													.replace(/<(?!br)([^>]+)>/g, ''), //NOSONAR
										timeStamp: TimeUtil.getCurrentTime(new Date()),
										messageType: 'user',
										isFeedbackVisible: true,
										key: null,
										customInfos: {},
										suggestionChips: [],
										hidden: config?.isHidden,
									},
							  ],
				};
			},
			() => {
				let chatInputElement = document.getElementById('chatInput');
				if (chatInputElement) {
					chatInputElement.innerText = '';
				}
				// if (
				// 	!this.state.data.isInsideAware &&
				// 	window.location.origin.indexOf(window['BASE_URL']) < 0
				// ) {
				// 	this.getApiuser().then((apiuser: string) => {
				// 		let data = JSON.parse(apiuser);
				// 		this.sendChatMessage(
				// 			chatInput,
				// 			data.sfUniqueId,
				// 			extraReqObj,
				// 			config
				// 		);
				// 	});
				// } else {
				if (
					this.state.redirectURL &&
					this.state.redirectURL.indexOf('livechat') > -1
				) {
					this.LivechatSocket.send(
						JSON.stringify({
							message: chatInput,
							metaData: {},
						})
					);
					this._scrollToBottom(true);
					return;
				} else if (
					this.state.freshChatSocketStatus === true &&
					this.state.redirectURL !== ''
				) {
					this.freshChatSocket.send(
						JSON.stringify({
							message: chatInput,
						})
					);
					return;
				} else {
					if (this.props.data.enableIntent) {
						this.getIntent(chatInput);
					} else this.sendChatMessage(chatInput, '', extraReqObj, config);
				}

				// }
			}
		);
	}
	handleTakeOverFromAgent() {
		if (this.state.wsagentinterventionSocket === false) {
			//open socket
			this.takeoverSocket = new WebSocket(
				// 'ws://' +
				socketName +
					'://' +
					window['CHAT_URL'] +
					'/HybridChat/wsAgentIntervention?apiuser=' +
					this.state.conversationalId
			);
			this.takeoverSocket.onopen = () => {
				saveStateSession('iswsagentIntervion', 'opened');
				this.wsAgentInterventionheartbeat();
			};
			this.setState({
				wsagentinterventionSocket: true,
			});
		}
		this.takeoverSocket.onclose = (ev: any) => {
			console.log(ev);
			if (
				ev.reason !== 'wsagentintervention Socket closing from UI' &&
				takeoversocketOpenCount <= 5
			) {
				//open socket
				this.takeoverSocket = new WebSocket(
					// 'ws://' +
					socketName + '://',
					window['CHAT_URL'] +
						'/HybridChat/wsAgentIntervention?apiuser=' +
						loadStateSession('sf-uniqueId')
				);
				takeoversocketOpenCount++;
			}
		};
		if (this.takeoverSocket) {
			this.takeoverSocket.onmessage = (event) => {
				const data = JSON.parse(event.data);
				if (data.openSocket === 'yes') {
					saveStateSession('userSessionId', data.userSessionId);
					const agentsessionid = data.agentSessionId;
					const sessionID = data.userSessionId;
					const IPaddress = data.IPaddress;
					let promise = new Promise((resolve, reject) => {
						this.setState(
							{
								handleUserDetailsPopUponTakeover: true,
							},
							() => {
								// saveStateSession("userResp", "proceed to connect");
								saveStateSession('userResp', 'Connected with user');
								this.setUpAgentListener({ sessionID, IPaddress });
								resolve('Success');
							}
						);
					});
					promise.then((res) => {
						if (res === 'Success') {
							return this.agentIntervention(
								agentsessionid,
								sessionID,
								IPaddress
							);
						}
					});
				}
			};
		}
	}

	getIntent = (chatInput) => {
		this.appendLoader();

		let payload = {
			id: this.state.conversationalId,
			message: chatInput,
			botId: this.props.botID.toString(),
			version: 'prod',
			country: loadStateSession('FS-country'),
			metaData: chatInput.metaData
				? chatInput.metaData
				: this.state.selectedProduct
				? this.state.selectedProduct
				: { productID: '', productName: '' },
			userId: loadStateSession('userId'),
		};

		fetch(window['BASE_URL'] + '/conversation/message/intent', {
			// credentials: 'include',
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'x-tenant-id': this.props.tenantID,
				Authorization: `Bearer ${loadStateSession('token')}`,
			},
			body: JSON.stringify(payload),
		})
			.then((data) => {
				return data.json();
			})
			.then((resp) => {
				let response = resp;
				// setMsgId(response.messageId);
				// setResponseId(response.id);
				this.sendChatMessage(
					chatInput,
					'',
					'',
					'',
					response.id,
					response.messageId
				);
			})
			.catch((error) => {});
	};

	sendChatMessage(chatInput, apiuser, extraReqObj, config?, respId?, msgId?) {
		if (!this.props.data.enableIntent) {
			this.appendLoader();
		}
		this.setState({
			chatInput: '',
			isChatStarted: true,
			userQuery: chatInput,
		});
		if (!config || !config.isFileUpload) {
			extraReqObj = {
				...extraReqObj,
				fileUpload: {
					uploadedFileDetails: {
						fileName: '',
						fileSize: '0',
					},
					uploadFileStatus: {
						isValidated: false,
						isFileUpload: false,
					},
				},
			};
		}
		// console.log(this.state.uniqueId);

		// &&
		// this.state.data.agentSupport === 'true';
		// if (!this.state.data.isInsideKampsta) {
		// 	payload.version = 'prod';
		// 	payload.mode = '';
		// 	if (this.isSafari()) {
		// 		payload.source = 'safari';
		// 	}
		// }
		// if(this.state.data.agentSupport === 'true'){

		// }

		// if (
		// 	this.state.data.authenticationMechanism === 'sso' &&
		// 	this.state.data.htmlElementIdForSSO
		// ) {
		// 	let htmlElementSSO = document.getElementById(
		// 		this.state.data.htmlElementIdForSSO
		// 	);
		// 	payload.userId = htmlElementSSO ? htmlElementSSO.innerText : '';
		// }
		//chat api call

		let apiname;
		let payload = {};
		// if (
		// 	!this.state.data.isInsideKampsta &&
		// 	this.state.data.agentSupport &&
		// 	this.state.data.agentSupport === 'true'
		// ) {
		// 	apiname = '/HybridChat/chat';
		// 	payload = {
		// 		q: chatInput,
		// 		apiuser: this.state.conversationalId,
		// 		mode: 'test',
		// 		version: 'prod',
		// 		botid: this.props.eB,
		// 		SF_BASE_URL: `${window['BASE_URL']}`,
		// 		source: 'webs',
		// 		lang: this.state.currentLanguageCode,
		// 		tenantId: this.props.tenantID,
		// 		...extraReqObj,
		// 	};
		// } else {
		apiname = loadStateSession('message_api_url') ?? '/messages/';
		payload = {
			id: respId ? respId : this.state.conversationalId,
			message: chatInput.metaData ? '' : chatInput,
			botId: this.props.botID.toString(),
			version: 'prod',
			country: this.state.currentCountry,
			msg_id: msgId ? msgId : null,
			metaData: chatInput.metaData
				? chatInput.metaData
				: this.state.selectedProduct
				? this.state.selectedProduct
				: '',
			//};
		};
		// DataAPI()
		// 	.post(apiname, payload)
		// 	.then((response) => {
		fetch(portApiName + window['CHAT_URL'] + apiname, {
			//credentials: 'include',
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'x-tenant-id': this.props.tenantID,
				Authorization: `Bearer ${this.state.bearerToken}`,
			},
			body: JSON.stringify(payload),
		})
			.then((data) => {
				if (data.status >= 500 && data.status < 600) {
					throw new Error('failed to fetch');
				}
				return data.json();
			})
			.then((response) => {
				// (!this.state.data.isInsideAware) &&
				// 	this.initSessionTimer();
				saveStateSession('messageId', response.messageId);
				saveStateSession('conversationId', response.id);

				this.setState({
					productCarousel: false,
					selectedProduct: {},
				});

				if (
					!response.status ||
					(response.status && response.status.toLowerCase() !== 'success')
				) {
					throw new Error(response.message);
				}

				if (response) {
					this.setState({
						failedCount: 0,
					});
				}
				if (response && response.metaData && response.metaData.form) {
					this.setState({
						formChatInputHidden: true,
						showForm: true,
					});
				} else {
					this.setState({
						formChatInputHidden: false,
						showForm: false,
					});
				}
				if (apiname.indexOf('HybridChat') > -1) {
					this.setState({
						conversationalId: response.conversationalId,
					});
				} else {
					this.setState(
						{
							conversationalId: response.id,
						},
						() => {
							if (
								response &&
								response.metaData &&
								response.metaData.get_products &&
								response.metaData.get_products === 'true'
							) {
							}
						}
					);
				}
				if (
					!this.state.data.isInsideAware ||
					!this.props.data.isInsideKampsta
				) {
					this.initSessionTimer();
				}

				if (
					!this.state.data.isInsideAware &&
					window.location.origin.indexOf(window['BASE_URL']) < 0
				) {
					let data = {
						sfUniqueId: apiuser,
						time: new Date().getTime(),
					};
					this.setState({
						uniqueId: data,
					});
					saveStateSession(this.state.data.eB, JSON.stringify(data));
				}
				if (response.agentChat) {
					this.setState(
						{
							redirectURL: response.redirect,
							freshChatSocketStatus: false,
						},
						() => {
							if (
								this.state.redirectURL &&
								this.state.redirectURL.indexOf('livechat') > -1
							) {
								this.handleHybridChatAgent();
							} else {
								this.handlefreshChatAgent();
							}
							this.addServerResponseShorthand(
								response.message,
								'server',
								true,
								response.messageId
							);
						}
					);
				} else {
					let obj = [];
					let categoryArray = [];
					response.metaData.categories &&
						response.metaData.categories.map((category, index) => {
							categoryArray[index] = response.metaData.products.filter(
								(item) => item.category === response.metaData.categories[index]
							);
						});

					response.metaData &&
						response.metaData.products &&
						response.metaData.products.map((item, index) => {
							this.setState({
								productCarousel: true,
							});
							return obj.push({
								resourceURL: item.image,
								title: item.title,
								price: item.price,
								description: '',
								cardIndex: index.toString(),
								productId: item.product_id,
								currency: item.currency,
								complimentary_product: item.complimentary_products,
								reasonQuery: item.reason_query,
								reasonDesc: item.reason,
							});
						});

					let imageLinks = [];
					response.metaData &&
						response.metaData.image_links &&
						response.metaData.image_links.map((item, index) => {
							return imageLinks.push({
								resourceURL: item,
								title: '',
								cardIndex: index.toString(),
								cardLayout: '8',
							});
						});

					let suggestionObj = [];
					response.suggestions &&
						response.suggestions.map((item) => {
							return suggestionObj.push({
								actionText: item,
								displayText: item,
								title: item,
							});
						});
					if (response) {
						if (response.metaData && response.metaData.form) {
							this.addServerResponse({
								responseElements: [
									{
										displayResponse: `WORKFLOW-${chatInput}-${response.messages}`,
										responseType: 'FORM',
										lists: response.metaData.form,
										isRichElement: true,
										messageId: response.messageId,
									},
								],
								messageId: response.messageId,
								errorFallbackLinks: this.state.data.quickLinksOnError,
								timeStamp:
									Date.now() + new Date().getTimezoneOffset() * 60 * 1000,
							});
						} else if (
							response.metaData &&
							response.metaData.products &&
							response.metaData.products.length === 0 &&
							response.metaData.details
						) {
							this.addServerResponse({
								responseElements: [
									{
										displayResponse: response.message,
										responseType: 'DETAILS',
										lists: response.metaData.details,
										isRichElement: true,
										messageId: response.messageId,
										quicklinks: { items: suggestionObj },
									},
								],
								messageId: response.messageId,
								errorFallbackLinks: this.state.data.quickLinksOnError,
								timeStamp:
									Date.now() + new Date().getTimezoneOffset() * 60 * 1000,
							});
						} else if (
							response.metaData &&
							response.metaData.image_links &&
							response.metaData.image_links.length > 0 &&
							(!response.metaData.products ||
								(response.metaData.products &&
									response.metaData.products.length == 0))
						) {
							if (imageLinks) {
								this.addServerResponse({
									responseElements: [
										{
											displayResponse: response.message,
											responseType: 'CAROUSEL',
											lists: { items: imageLinks },
											listResponseType: 'MULTICHOICE',
											isRichElement: true,
											messageId: response.messageId,
											quicklinks: { items: suggestionObj },
											type: 'nonproduct',
										},
										{
											displayResponse: '',
											responseType: 'MULTICHOICE',
											lists: { items: suggestionObj },
											listResponseType: 'MULTICHOICE',
											type: 'QUICKLINKS',
											messageId: response.messageId,
										},
									],
									messageId: response.messageId,
									errorFallbackLinks: this.state.data.quickLinksOnError,
									timeStamp:
										Date.now() + new Date().getTimezoneOffset() * 60 * 1000,
								});
							}
						} else if (
							response.metaData &&
							response.metaData.products &&
							response.metaData.products.length > 0 &&
							response.metaData.categories &&
							response.metaData.categories.length > 0
						) {
							this.setState({
								secondAPI:
									response &&
									response.metaData &&
									response.metaData.get_products &&
									response.metaData.get_products === 'true'
										? true
										: false,
							});
							this.addServerResponse({
								responseElements: [
									{
										displayResponse: response.message,
										responseType: 'CAROUSEL',
										lists: { items: categoryArray },
										listResponseType: 'MULTICHOICE',
										isRichElement: true,
										messageId: response.messageId,
										quicklinks: { items: suggestionObj },
										id: this.state.conversationalId,
										message: chatInput,
										botId: this.props.botID.toString(),
										version: 'prod',
										country: this.state.currentCountry,
										metaData: response.metaData,
										tenantID: this.props.tenantID,
										token: this.state.bearerToken,
										secondAPI:
											response &&
											response.metaData &&
											response.metaData.get_products &&
											response.metaData.get_products === 'true'
												? true
												: false,
									},
									{
										displayResponse: 'carouselchoice',
										responseType: 'MULTICHOICE',
										lists: { items: suggestionObj },
										listResponseType: 'MULTICHOICE',
										type: 'QUICKLINKS',
										messageId: response.messageId,
									},
								],
								messageId: response.messageId,
								errorFallbackLinks: this.state.data.quickLinksOnError,
								timeStamp:
									Date.now() + new Date().getTimezoneOffset() * 60 * 1000,
							});
						} else {
							this.addServerResponse(
								!response.metaData ||
									(response.metaData.products &&
										response.metaData.products.length == 0 &&
										response.suggestions &&
										response.suggestions.length > 0)
									? {
											responseElements: [
												{
													displayResponse: response.metaData
														? response.message
														: response.message,
													responseType: 'SIMPLE',
													messageId: response.messageId,
													lists: { items: suggestionObj },
												},
												{
													displayResponse: '',
													responseType: 'MULTICHOICE',
													lists: { items: suggestionObj },
													listResponseType: 'MULTICHOICE',
													type: 'QUICKLINKS',
													messageId: response.messageId,
												},
											],
											messageId: response.messageId,
											errorFallbackLinks: this.state.data.quickLinksOnError,
											timeStamp:
												Date.now() + new Date().getTimezoneOffset() * 60 * 1000,
									  }
									: {
											responseElements: [
												{
													displayResponse: response.message,
													responseType: 'SIMPLE',
													messageId: response.messageId,
												},
											],
											messageId: response.messageId,
											errorFallbackLinks: this.state.data.quickLinksOnError,
											timeStamp:
												Date.now() + new Date().getTimezoneOffset() * 60 * 1000,
									  }
							);
						}
					}
				}

				if (Timer.hasStarted) {
					Timer.restart();
				} else {
					Timer.start(15, 'min');
				}

				if (
					!this.state.data.isInsideKampsta &&
					this.state.data.agentSupport &&
					this.state.data.agentSupport === 'true'
				) {
					this.handleTakeOverFromAgent();
				}
				// window["setSessionInterval"] = setInterval(() => {
				//   DataAPI()
				//     .post("/SessionKeepAlive", {
				//       logout: true,
				//       isAgent: false,

				//       apiuser: loadStateSession("sf-uniqueId"),
				//     })
				//     .then((res: any) => {
				//       this.setState(
				//         (prevState) => {
				//           return {
				//             JSESSIONID: res.data.curSessId,
				//             previousJSESSIONID: prevState.JSESSIONID,
				//           };
				//         },
				//         () => {
				//           if (
				//             this.state.JSESSIONID !==
				//               this.state.previousJSESSIONID &&
				//             this.state.previousJSESSIONID !== ""
				//           ) {
				//             this.callOpenSocket();
				//           }
				//         }
				//       );
				//     });
				//   // }, 300000);
				// }, 30000);
			})

			.catch((error) => {
				this.setState({
					productCarousel: false,
				});
				this.setState(
					{
						failedCount: this.state.failedCount + 1,
					},
					() => {
						if (this.state.failedCount == 1) this.restartSession();
						// setTimeout(() => {
						// 	this.setState({
						// 		failedCount: 0,
						// 	});
						// }, 3000);
					}
				);
				let offlineMessage = `Aw snap! Can you please try that again?`;
				if (error.message) {
					offlineMessage = error.message;
					if (
						error.message.toLowerCase() === 'failed to fetch' ||
						error.message.toLowerCase().indexOf('unexpected token') > -1
					) {
						offlineMessage = `Couldn't connect to the server. Please Retry. If the issue persist check your connection and try again later.`;
					}
				}
				if (!this.state.isConnectedToNetwork) {
					offlineMessage = 'Seems like you are not connected to a network.';
				}
				if (this.state.isBotVisible && this.state.failedCount > 1)
					this.addServerResponse({
						responseElements: [
							{ displayResponse: offlineMessage, responseType: 'SIMPLE' },
						],
						errorFallbackLinks: this.state.data.quickLinksOnError,
						timeStamp: Date.now() + new Date().getTimezoneOffset() * 60 * 1000,
					});
				console.log(error);
				this.removeLoader();
			});
	}

	mdToJSON(md) {
		//var reg = MDUtil.linkRegex;
		//regex lastIndex stupidity with //g so have declared a local
		var res = /#_#.?{(.*?)}.?{(.*?)}.?{(.*?)}/.exec(md);
		//SPUPID format below
		var obj = { Type: 'disamb', actionText: res[2], displayText: res[3] };

		return obj;
	}

	getArrayFromLinkText(links) {
		return links.map((e) => {
			return this.mdToJSON(MDUtil.convertAutoSubmitHtmlToSFMarkdown(e.link));
		});
	}
	b64toBlob(b64Data, contentType = '', sliceSize = 512) {
		const byteCharacters = atob(b64Data);
		const byteArrays = [];

		for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
			const slice = byteCharacters.slice(offset, offset + sliceSize);

			const byteNumbers = new Array(slice.length);
			for (let i = 0; i < slice.length; i++) {
				byteNumbers[i] = slice.charCodeAt(i);
			}

			const byteArray = new Uint8Array(byteNumbers);
			byteArrays.push(byteArray);
		}

		const blob = new Blob(byteArrays, { type: contentType });
		return blob;
	}
	// prepareAudioData(audioArray, playAudioCall) {
	//   let eB = this.state.data.eB;
	//   let streamDelay = 0;
	//   let resultArr = [];
	//   let countFlag = 0;
	//   let systemTime;
	//   let timeArr = [];
	//   let diff;
	//   let setDelay;
	//   let result;
	//   let status: boolean;
	//   let wsurl =
	//     'wss://' +
	//     window['BASE_URL'].replace(/(^\w+:|^)\/\//, '') +
	//     '/ttsservice/texttospeech/generate';
	//   let socket = new WebSocket(wsurl);
	//   for (let i = 0; i < audioArray.length && this.state.isBotVisible; i += 1) {
	//     socket.onopen = function(e) {
	//       socket.send(
	//         JSON.stringify({
	//           inputText: audioArray[i].replace(/&nbsp;/g, ' '),
	//           gender: 'F',
	//           languageCode: 'en-IN',
	//           botID: encodeURIComponent(eB)
	//         })
	//       );
	//     };
	//   }
	//   /* socket.close()*/
	//   socket.onmessage = event => {
	//     result = event.data;
	//     let time = 0;
	//     status = JSON.parse(event.data).recognized;
	//     time = JSON.parse(result).duration;
	//     result = JSON.parse(result).encodedByteString;
	//     if (result != null) {
	//       resultArr.push(result);
	//     }
	//     if (!status) {
	//       const date = new Date();
	//       systemTime = date.getTime();
	//       timeArr.push(systemTime);

	//       if (countFlag > 0) {
	//         diff = (timeArr[countFlag] - timeArr[0]) / 1000;
	//       }
	//       countFlag++;
	//       setDelay = streamDelay - diff;

	//       setTimeout(() => {
	//         playAudioCall([result]);
	//       }, setDelay * 1000);
	//       if (setDelay < 0) {
	//         streamDelay = diff + time;
	//       } else {
	//         streamDelay += time;
	//       }
	//     } else {
	//       socket.close();
	//     }
	//   };
	//   socket.onclose = function(event) {
	//     if (event.wasClean) {
	//       console.log(
	//         `Connection closed cleanly, code=${event.code} reason=${event.reason}`
	//       );
	//     } else {
	//       // e.g. server process killed or network down // event.code is usually 1006 in this case
	//       console.log('Connection died');
	//     }
	//   };

	//   socket.onerror = function(error) {
	//     console.log(`[error]`);
	//   };

	//   // for (let i = 0; i < audioArray.length && this.state.isBotVisible; i += 1) {
	//   //   // https://awareuat.senseforth.com:8443/speech/generate //old api for tts
	//   //   promiseArray.push(
	//   //     fetch(`${window['BASE_URL']}/speech/tts`, {
	//   //       credentials: 'include',
	//   //       method: 'POST',
	//   //       headers: {
	//   //         'Content-Type': 'application/json'
	//   //       },
	//   //       body: JSON.stringify({
	//   //         gender: 'F',
	//   //         searchQuery: audioArray[i].replace(/&nbsp;/g, ' '),
	//   //         languageCode: this.state.currentLanguageCode,
	//   //         botID: encodeURIComponent(this.state.data.eB)
	//   //       })
	//   //     })
	//   //   );
	//   // }
	//   // return Promise.all(promiseArray).then(values => {
	//   //   let jsonArray = [];
	//   //   values.forEach(v => {
	//   //     jsonArray.push(v.json());
	//   //   });
	//   //   return jsonArray;
	//   // });
	// }
	prepareAudioData(audioArray, playAudioCall) {
		let eB = this.state.data.eB;

		let wsurl =
			'wss://' +
			window['BASE_URL'].replace(/(^\w+:|^)\/\//, '') +
			'/ttsservice/texttospeech/generate';

		let socket = new WebSocket(wsurl);
		for (let i = 0; i < audioArray.length && this.state.isBotVisible; i += 1) {
			socket.onopen = function (e) {
				socket.send(
					JSON.stringify({
						inputText: audioArray[i].replace(/&nbsp;/g, ' '),
						gender: 'F',
						languageCode: 'en-IN',
						botID: encodeURIComponent(eB),
					})
				);
			};
		}
		let streamDelay = 0;
		let countFlag = 0;
		let systemTime;
		let timeArr = [];
		let diff;
		let setDelay;
		/* socket.close()*/
		socket.onmessage = (event) => {
			let result = event.data;
			let time = 0;
			let status = JSON.parse(result).recognized;
			time = JSON.parse(result).duration;
			result = JSON.parse(result).encodedByteString;

			if (!status) {
				const date = new Date();
				systemTime = date.getTime();
				timeArr.push(systemTime);

				if (countFlag > 0) {
					diff = (timeArr[countFlag] - timeArr[0]) / 1000;
				}
				countFlag++;

				setDelay = streamDelay - diff;

				setTimeout(() => {
					playAudioCall([result]);
				}, setDelay * 1000);
				if (setDelay < 0) {
					streamDelay = diff + time;
				} else {
					streamDelay += time;
				}
			} else {
				socket.close();
			}
		};
		socket.onclose = function (event) {
			if (event.wasClean) {
				console.log(
					`Connection closed cleanly, code=${event.code} reason=${event.reason}`
				);
			} else {
				// e.g. server process killed or network down // event.code is usually 1006 in this case
				console.log('Connection died');
			}
		};

		socket.onerror = function (error) {
			console.log(`[error]`);
		};

		// for (let i = 0; i < audioArray.length && this.state.isBotVisible; i += 1) {
		//   // https://awareuat.senseforth.com:8443/speech/generate //old api for tts
		//   promiseArray.push(
		//     fetch(`${window['BASE_URL']}/speech/tts`, {
		//       credentials: 'include',
		//       method: 'POST',
		//       headers: {
		//         'Content-Type': 'application/json'
		//       },
		//       body: JSON.stringify({
		//         gender: 'F',
		//         inputText: audioArray[i].replace(/&nbsp;/g, ' '),
		//         languageCode: this.state.currentLanguageCode,
		//         botID: encodeURIComponent(this.state.data.eB)
		//       })
		//     })
		//   );
		// }
		// return Promise.all(promiseArray).then(values => {
		//   let jsonArray = [];
		//   values.forEach(v => {
		//     jsonArray.push(v.json());
		//   });
		//   return jsonArray;
		// });
	}
	getProductDescription = (meta, query) => {};

	playAudio = (audioArray) => {
		/**
		 * audioArray is an array of promises which whill resolve to parsedJSON
		 */

		/**
		 * Stop any audio being played
		 */
		// this.stopSpeaking();
		let arrayOfAudioElements = [];
		let blob = this.b64toBlob(audioArray[0], 'audio/wav');
		let url = window.URL.createObjectURL(blob);
		let audio = document.createElement('audio');
		audio.src = url;
		arrayOfAudioElements.push(audio);
		if (!this.pauseAudio) {
			audio.play();
		}
		// for (let i = 0; i < audioArray.length; i += 1) {
		//   fakePromise = fakePromise.then(_ => {
		//     return new Promise<void>(res => {
		//       audioArray[i]
		//         .then(parsedAsJson => {
		//           /**
		//            * herer parsedAsJson is the actual response came from api
		//            */
		//           fetch(
		//             `data:${parsedAsJson.contentType};base64,${parsedAsJson.encodedByteString}`
		//           )
		//             .then(data => data.blob())
		//             .then(blob => {
		//               let url = window.URL.createObjectURL(blob);
		//               let audio = document.createElement('audio');
		//               audio.src = url;
		//               audio.onended = () => res();
		//               arrayOfAudioElements.push(audio);
		//               if (this.state.isBotVisible && this.state.speakingEnabled)
		//                 audio.play();
		//             });
		//         })
		//         .catch(err => {
		//           console.log(err);
		//         });
		//     });
		//   }) as any;
		// }
		// overwrite the contents of audioArray class variable
		this.audioArray = arrayOfAudioElements;
	};

	toggleLoginScreen = (url) => {
		this.setState({
			showLoginScreen: !this.state.showLoginScreen,
			oauthURL: url,
		});
	};

	addServerResponse(data, messageType?: string, fromLiveAgent?: boolean) {
		if (data.agentChat) {
			this.handleLiveChat(
				data.conversationalId,
				'127.0.0.1', //ipaddress
				data.responseElements
				// data.triggerEmail
			);
			this.removeLoader();
			return;
		}
		this.removeLoader();
		var answer = data.responseElements ? data.responseElements : data;
		var disamb = data.disamb ? this.getArrayFromLinkText(data.disamb) : [];

		if (Boolean(data.disambQuestions) && data.disambQuestions.length > 0) {
			disamb = data.disambQuestions;
		} else if (
			Boolean(data.relatedQuestions) &&
			data.relatedQuestions.length > 0
		) {
			disamb = data.relatedQuestions;
		} else if (Boolean(data.suggestions) && data.suggestions.length > 0) {
			disamb = data.suggestions;
		}
		var errorFallbackLinks = data.errorFallbackLinks || false;

		// data.isOauthLoggedin = true;
		this.setState({
			isUserLoggedin: data.isOauthLoggedin,
		});

		if (data.NonComprehendFlag && errorFallbackLinks) {
			//Show quick links only when CouldNotComprehend
			errorFallbackLinks = true;
		}

		/**
		 * Check for audio response
		 */
		const voiceResponse = !!(
			this.micUsed &&
			this.state.data.speechSupport == 'true' &&
			this.state.speakingEnabled
		);

		this.micUsed = false;
		this.setState({
			voiceResponse: voiceResponse,
		});

		if (this.state.voiceResponse) {
			let speechTextArray = [];
			answer.forEach((eachAnswer) => {
				if (
					eachAnswer.responseType === 'SIMPLE' &&
					eachAnswer.speechResponse &&
					eachAnswer.speechResponse.length > 0
				) {
					speechTextArray.push(eachAnswer.speechResponse);
				}
			});
			// let playAudioCall = this.playAudio;

			let playAudioCall = this.playAudio.bind(this);
			this.prepareAudioData(speechTextArray, playAudioCall);
			// .then(data => this.playAudio(data));
			// .catch(err => console.log(err));
		}
		/**
		 * Remove audio responses from answer array
		 */
		answer = answer.filter((eachAnswer) => {
			/**
			 * disable input for multi choice/select answers
			 *
			 */
			if (
				eachAnswer &&
				eachAnswer.listResponseType &&
				(eachAnswer.listResponseType === 'MULTISELECT' ||
					eachAnswer.listResponseType === 'MULTICHOICE')
			) {
				this.setState({
					isChatInputHidden: eachAnswer.isRichElement,
				});
			} else {
				if (
					eachAnswer.displayResponse !==
					'Say exit or cancel to stop this conversation'
				)
					this.setState({
						isChatInputHidden: false,
						isChatInputDisabled: data.isChatInputDisabled,
					});
			}

			/**
			 * Check whether bubble is only a speech response type or not
			 */
			let isOnlySpeechResponse = false;
			if (eachAnswer.responseType === 'SIMPLE')
				if (
					eachAnswer.speechResponse &&
					!eachAnswer.displayResponse &&
					!eachAnswer.actualResponse
				)
					isOnlySpeechResponse = true;
			return !isOnlySpeechResponse;
		});

		this.setState(
			(prevState) => {
				/**
				 * while inserting new message from server,
				 * remove preloader image
				 */
				// if (!this.state.voiceResponse) {
				// 	setTimeout(() => {
				// 		let focusElement;
				// 		if (
				// 			data.workflowTrigger === 'Rating_task' ||
				// 			onlySpecialCharactersEntered
				// 		) {
				// 			const serverWrappers = document.querySelectorAll(
				// 				'.msg-server-wrapper .preview-image-holder'
				// 			);
				// 			const latestServerWrapper =
				// 				serverWrappers[serverWrappers.length - 1];
				// 			focusElement = latestServerWrapper.nextSibling;
				// 		} else {
				// 			const usrWrappers =
				// 				document.querySelectorAll('.msg-user-wrapper');
				// 			const latestusrWrapper = usrWrappers[usrWrappers.length - 1];
				// 			let serverWrapper =
				// 				latestusrWrapper && latestusrWrapper.nextSibling;
				// 			const serverWrapperPreviewImageHolder = (
				// 				serverWrapper as HTMLElement
				// 			).querySelector('.preview-image-holder');
				// 			focusElement =
				// 				serverWrapper && serverWrapperPreviewImageHolder !== null
				// 					? serverWrapperPreviewImageHolder.nextSibling
				// 					: '';
				// 		}
				// if (!this.state.voiceResponse) {
				// 	setTimeout(() => {
				// 		let focusElement;
				// 		if (
				// 			data.workflowTrigger === 'Rating_task' ||
				// 			onlySpecialCharactersEntered
				// 		) {
				// 			const serverWrappers = document.querySelectorAll(
				// 				'.msg-server-wrapper .preview-image-holder'
				// 			);
				// 			const latestServerWrapper =
				// 				serverWrappers[serverWrappers.length - 1];
				// 			focusElement = latestServerWrapper.nextSibling;
				// 		} else {
				// 			const usrWrappers =
				// 				document.querySelectorAll('.msg-user-wrapper');
				// 			const latestusrWrapper = usrWrappers[usrWrappers.length - 1];
				// 			let serverWrapper =
				// 				latestusrWrapper && latestusrWrapper.nextSibling;
				// 			const serverWrapperPreviewImageHolder = (
				// 				serverWrapper as HTMLElement
				// 			).querySelector('.preview-image-holder');
				// 			focusElement =
				// 				serverWrapper && serverWrapperPreviewImageHolder !== null
				// 					? serverWrapperPreviewImageHolder.nextSibling
				// 					: '';
				// 		}

				// 		focusElement && (focusElement as HTMLElement).focus();
				// 	}, 100);
				// }
				// 		focusElement && (focusElement as HTMLElement).focus();
				// 	}, 100);
				// }
				return {
					chatMessages: [
						...prevState.chatMessages.filter((e) => e.key != 'preloader'),
						{
							message: answer,
							suggestions: disamb,
							timeStamp: TimeUtil.getCurrentTime(
								new Date(
									new Date(data.timeStamp).getTime() -
										new Date().getTimezoneOffset() * 60 * 1000
								)
							),
							messageType: messageType || 'server',
							key: data.key ? data.key : data.caId,
							errorFallbackLinks,
							searchStatus: data.searchStatus,
							showFeedbackIcons: data.showFeedbackIcons
								? data.showFeedbackIcons
								: true,
							workflowFlag: data.workFlowflag,
							triggerOauth: data.triggerOauth,
							promptLogin: data.promptLogin,
							customInfos: [
								{ EntityName: data.EntityName },
								{ entityID: data.entityID },
								{ intentID: data.intentID },
								{ intentName: data.intentName },
								{ disambFlag: data.disambflag },
							],
							extra: data.extra,
							diagnosticInfo: data.diagnosticInfo,
							extraDisambInformation: {
								matchedEntity: data.matchedEntity,
								matchedIntent: data.matchedIntent,
								matchedQn: data.matchedQn,
								entityHeirarchy: data.entityHeirarchy,
								semantics: data.semantics,
								variationMatched: data.variationMatched,
								intentScore: data.intentScore,
								intentNotMatch: data.intentNotMatch,
								reverseIntentScore: data.reverseIntentScore,
								reverseIntentNotMatch: data.reverseIntentNotMatch,
								semanticsSequence: data.semanticsSequence,
								entityInContext: data.entityInContext,
							},
							suggestionChips: data.suggestions,
							messageId: data.messageId,
							thumbFilledUp: data.thumbFilledUp ? data.thumbFilledUp : null,
						},
					],
					isChatInputDisabled: data.isChatInputDisabled,
					isAutoSuggest: data.isAutoSuggest,
					autoSuggestApiDetails: data.autoSuggestApiDetails,
					taskId: data.taskId,
					workflowId: data.workflowId,
				};
			},
			() => {
				this._scrollToBottom(fromLiveAgent);
				this.disableActionLinks();
				this.removeLoader();
				/* Oauth - showing Login screen using Oauth url */
				setTimeout(() => {
					if (
						data.triggerOauth &&
						data.triggerOauth != '' &&
						data.promptLogin === false
					) {
						this.toggleLoginScreen(data.triggerOauth);
					}
				}, 1000);
			}
		);
		/**
		 * Detect Location
		 */
		if (data.detectLocation) {
			if (window.navigator && window.navigator.geolocation) {
				window.navigator.geolocation.getCurrentPosition(
					(success) => {
						this.handleSubmit(
							`${success.coords.latitude},${success.coords.longitude}`,
							{}
						);
					},
					(err) => {
						this.addServerResponse({
							responseElements: [
								{
									displayResponse: err.message,
									responseType: 'SIMPLE',
								},
							],
							errorFallbackLinks: this.state.data.quickLinksOnError,
							timeStamp:
								Date.now() + new Date().getTimezoneOffset() * 60 * 1000,
						});
					}
				);
			}
		}
	}

	initSessionTimer() {
		let totalSessionTimeout =
			Number(this.state.data.apiSessionTimeoutInMins) || 5;

		let waitingTime = truthyOrFalsy(
			this.state.data.isAdvanceTimoutWarningEnabled
		)
			? Number(this.state.data.sessionExpiryWarningTimeInSecs) || 120
			: 120;

		// let timelimit = totalSessionTimeout * 60 - waitingTime;

		let timelimit = 3300;

		clearTimeout(this.sessionTimer);

		this.sessionTimer = setTimeout(() => {
			this.setState({
				isModalVisible: true,

				isBotSessionTimeout: true,
			});
		}, timelimit * 1000);
	}

	appendLoader(config?: { appengToRight: boolean }) {
		this.setState(
			(prevState) => {
				return {
					disableRefresh: true,
					chatMessages: [
						...prevState.chatMessages,
						{
							message: "<div class='sf-preloader-img'></div>",
							timeStamp: '',
							messageType: 'server',
							isFeedbackVisible: false,
							key: 'preloader',
							customInfos: {},
							suggestionChips: [],
						},
					],
				};
			},
			() => {
				// this._scrollToBottom("srv")
				this._scrollToBottom();
				this.disableActionLinks();
			}
		);
	}

	removeLoader() {
		this.setState((state) => ({
			disableRefresh: false,

			chatMessages: state.chatMessages.filter((e) => e.key != 'preloader'),
		}));
		// if (
		//   this.state.chatMessages[this.state.chatMessages.length - 2]
		//     .messageType === "server"
		// ) {
		//   this._scrollToBottom("srv");

		// } else {
		//   this._scrollToBottom("senseforth");
		// }
	}

	// _scrollToBottom(peer) {
	//   if (!this.box.current) {
	//     return;
	//   }

	//   var box = this.box.current,
	//     t = box.scrollHeight,
	//     h = box.lastElementChild && box.lastElementChild.clientHeight,
	//     prev = 0;
	//   const elem = document.querySelector(".sf-chatbody");

	//   if (peer == "top") {
	//     elem.scrollTop = 0;
	//   } else if (peer == "Me") {
	//     box.scrollTop = t;
	//     var g = t * 1;
	//     prev = g;
	//   } else if (peer == "srv") {
	//     try {
	//       const allWrappers = document.querySelectorAll(
	//         ".msg-server-wrapper"
	//       ) as any;

	//       if (allWrappers.length > 0)
	//         elem.scrollTop =
	//           allWrappers[allWrappers.length - 1].offsetTop +
	//           allWrappers[allWrappers.length - 1].clientHeight;
	//     } catch (e) {
	//       console.log(e);
	//     }
	//   } else {
	//     try {
	//       const allWrappers = document.querySelectorAll(
	//         ".msg-user-wrapper"
	//       ) as any;

	//       if (allWrappers.length > 0)
	//         elem.scrollTop =
	//           allWrappers[allWrappers.length - 1].offsetTop +
	//           allWrappers[allWrappers.length - 1].clientHeight;
	//     } catch (e) {
	//       console.log(e);
	//     }
	//   }
	// }
	_scrollToBottom(fromLiveAgent?: boolean) {
		if (!fromLiveAgent) {
			const userMessages = document.querySelectorAll(
				'.msg-user-wrapper'
			) as NodeListOf<HTMLElement>;
			if (userMessages.length > 0) {
				const chatbodyWrapper = document.querySelector('.sf-chatbody');
				setTimeout(() => {
					chatbodyWrapper.scrollTo({
						top: userMessages.item(userMessages.length - 1).offsetTop - 100,
					});
				}, 500);
			}
		} else {
			const msgWrappers = document.querySelectorAll(
				'.msg-wrapper'
			) as NodeListOf<HTMLElement>;
			msgWrappers.length > 0 &&
				msgWrappers
					.item(msgWrappers.length - 1)
					.scrollIntoView({ block: 'start' });
		}
	}
	hideBot() {
		let scrollableBody = document.querySelector('.ff-leadgen-body')
			? document.querySelector('.ff-leadgen-body')
			: !this.state.isOverlayVisible
			? document.querySelector('.sf-chatbody')
			: document.querySelector('#sfOffersRoll');

		var chatbot = document.querySelector('.sf-chatbot');
		chatbot.classList.remove('show-bot');
		chatbot.classList.add('hide-bot');
		setTimeout(() => {
			this.setState({
				isBotVisible: false,
				predSearchToggle: false,
				lastScroll: scrollableBody.scrollTop,
				conversationalId: 0,
			});
		}, 200);
	}
	apiclearsession(override?: any, cb?: Function) {
		sessionStorage.removeItem(this.state.data.eB);
		sessionStorage.removeItem('sf-uniqueId');
		clearTimeout(this.sessionTimer);
		this.setState(
			(state) => {
				return {
					...this.setInitialState(),
					languageCodes: state.languageCodes,
					conversationalId: 0,
					...override,
				};
			},
			() => {
				if (cb) {
					cb();
				}
			}
		);
		// this._scrollToBottom("top");
		//this.checkApiUserToken();
		this._scrollToBottom();
	}
	clearSession(override?: any, cb?: Function) {
		if (document.getElementById('sfChatInputMain')) {
			document.getElementById('sfChatInputMain').style.visibility = 'visible';
		}

		// if (!this.props.data.isInsideKampsta) {
		// 	this.apiclearsession(override, cb);

		// 	if (
		// 		!this.props.data.isInsideKampsta &&
		// 		this.state.data.agentSupport.toLowerCase() === 'true'
		// 	) {
		// 		fetch(
		// 			portApiName + `${window['CHAT_URL']}/HybridChat/clearSessionInHybrid`,
		// 			{
		// 				credentials: 'include',
		// 				method: 'POST',
		// 				headers: {
		// 					'Content-Type': 'application/json',
		// 				},
		// 				body: JSON.stringify({
		// 					// botID: this.props.data.eB, //"k8aTRpmKSwddYR8m4uvZBg==",
		// 					// botid: decodeURIComponent(this.props.data.eB), //"k8aTRpmKSwddYR8m4uvZBg=="),
		// 					// version: 'prod',
		// 					botid: this.props.botID.toString(),
		// 					SF_BASE_URL: `${window['BASE_URL']}`,
		// 					// SF_CHAT_URL: `${window['CHAT_URL']}`,
		// 					apiuser: loadStateSession('sf-uniqueId'),
		// 				}),
		// 			}
		// 		)
		// 			.then((data) => data.json())
		// 			.then((response) => {
		// 				// Timer.start(15, "min");
		// 				// resolve && resolve("Success");
		// 				// this.setState(this.setInitialState());
		// 				sessionStorage.removeItem(this.state.data.eB);
		// 				sessionStorage.removeItem('sf-uniqueId');
		// 				clearTimeout(this.sessionTimer);
		// 				this.setState(
		// 					(state) => {
		// 						return {
		// 							...this.setInitialState(),
		// 							languageCodes: state.languageCodes,
		// 							...override,
		// 						};
		// 					},
		// 					() => {
		// 						if (cb) {
		// 							cb();
		// 						}
		// 					}
		// 				);
		// 				this.checkApiUserToken();
		// 				this._scrollToBottom();

		// 				// this.clearSessionInterval();
		// 			});
		// 	}
		// } else {
		this.apiclearsession(override, cb);
		// }
	}
	toggleSessionTimeoutPopUp = (state, override) => {
		if (state == 'clearSession' && override) {
			console.log('clearSession');
			if (
				!this.state.data.isInsideKampsta &&
				this.state.data.agentSupport &&
				this.state.data.agentSupport === 'true'
			) {
				if (
					this.takeoverSocket &&
					this.takeoverSocket.readyState === WebSocket.OPEN
				) {
					this.takeoverSocket.close(
						1000,
						'wsagentintervention Socket closing from UI'
					);

					console.log('socket closing on AI close after timer');
				}

				if (this.state.wsendpointSocketStatus !== 'closed') {
					this.chatSocket && this.chatSocket.close();
				}
			}
			this.clearSession({
				isBotVisible: state,
				botName: this.state.botName,
				welcomeMessage: this.state.welcomeMessage,
				launcherPromptMessage: this.state.launcherPromptMessage,
				chatMessages: [
					{
						message: [
							{
								displayResponse: this.state.welcomeMessage,
								responseType: 'SIMPLE',
							},
						],
						timeStamp: TimeUtil.getCurrentTime(new Date()),
						key: null,
						messageType: 'server',
						customInfos: {},
						suggestionChips: [],
					},
				],
				isLanguageListVisible: false,
			});
			this.setState({
				sessionComplete: !this.state.sessionComplete,
			});
		} else if (state == 'clearSession') {
			this.clearSession({
				currentLanguageCode: this.props.data.defaultLanguage,
			});
		} else if (state === 'keepalive') {
			this.initSessionTimer();
		}
		this.setState({
			isModalVisible: !this.state.isModalVisible,
			isBotSessionTimeout: !this.state.isBotSessionTimeout,
		});
	};

	closeModal() {
		const isLoadedFromAgentDashboard =
			window.location.href.indexOf('source=agent') > -1;
		if (
			!this.state.data.isInsideKampsta &&
			this.state.data.agentSupport &&
			this.state.data.agentSupport === 'true'
		) {
			if (
				this.takeoverSocket &&
				this.takeoverSocket.readyState === WebSocket.OPEN
			) {
				this.takeoverSocket.close(
					1000,
					'wsagentintervention Socket closing from UI'
				);

				console.log('socket closing on bot close');
			}

			if (this.state.wsendpointSocketStatus !== 'closed') {
				this.chatSocket && this.chatSocket.close();

				setTimeout(() => {
					// if (this.state.wsendpointSocketStatus === "closed") {
					this.setState(
						{
							// clearSessionBtnDisable: true,
							conversationalId: 0,
						},
						() => {
							if (!isLoadedFromAgentDashboard) {
								this.clearSession();
							}
						}
					);
					// }
				}, 500);
			} else {
				this.setState(
					{
						// clearSessionBtnDisable: true,
						conversationalId: 0,
					},
					() => {
						if (!isLoadedFromAgentDashboard) {
							this.clearSession();
						}
					}
				);
			}
		} else {
			this.clearSession({
				currentLanguageCode: this.props.data.defaultLanguage,
				sessionCleared: true,
			});
		}
	}
	handleModalToggle(
		callClearSession = false,
		isFeedback = false,
		close = false
	) {
		if (this.state.chatMessages.length < 2 && close) {
			this.hideBot();
			if (callClearSession) {
				// this.clearSession({
				// 	currentLanguageCode: this.props.data.defaultLanguage,
				// 	sessionCleared: true,
				// });

				this.closeModal();
			} else {
				this.setState({
					currentLanguageCode: this.state.currentLanguageCode,
				});
			}
			return;
		}

		this.setState(
			(prevState) => {
				return { isChatBodyVisible: true };
			},
			() => {
				// const isLoadedFromAgentDashboard =
				// 	window.location.href.indexOf('source=agent') > -1;

				if (callClearSession) {
					console.log('call clear');
					this.closeModal();
					this.setState({
						isModalVisible: !this.state.isModalVisible,
						showFeedbackPopup: false,
					});
				} else {
					console.log('not called clear');
					this.setState({
						isModalVisible: this.state.showFeedbackPopup
							? false
							: !this.state.isModalVisible,
						showFeedback: isFeedback,
						showFeedbackPopup: false,
						botClosingModal: close,
						sessionCleared: true,
						currentLanguageCode: this.state.currentLanguageCode,
					});
					if (isFeedback) {
						setTimeout(() => {
							var el = document.querySelector('.modal-title');
							el && (el as HTMLElement).focus();
						}, 100);
						setTimeout(() => {
							var el = document.querySelector('.modal-title');
							el && (el as HTMLElement).focus();
						}, 100);
					}
				}
			}
		);
	}
	popUpSnackBar = (msg: string) => {
		this.setState({
			snackBarMessage: msg,
		});
		setTimeout(() => {
			this.setState({
				snackBarMessage: '',
			});
		}, 4000);
	};

	internalFeedbackBanner = () => {
		if (!this.state.internalFeedbackErrorBlock) {
			this.setOtherToaster(
				'Feedback collected inside Flyfish AI won’t reflect in AI analytics.',
				[
					{
						label: TString({
							labelName: 'dismissLabel',
							langCode: 'en', //this.state.currentLanguageCode,
							fromClass: true,
						}),
						onClick: () => this.closeToaster(),
					},
					{
						label: TString({
							labelName: 'dontShowLabel',
							langCode: 'en', //this.state.currentLanguageCode,
							fromClass: true,
						}),
						onClick: () =>
							this.setState(
								{
									internalFeedbackErrorBlock: true,
									isModalVisible: false,
								},
								() => {
									this.closeToaster();
								}
							),
					},
				],
				true
			);
		}
	};
	handleToaster = () => {
		this.setState({
			showToaster: true,
		});
		setTimeout(() => {
			this.setState({
				showToaster: false,
			});
		}, 3000);
	};

	submitFeedback = (star = false, comment = '', msgRate, msgId) => {
		this.setState({
			showFeedbackPopup: false,
			isModalVisible: false,
		});
		if (star === false && comment === '') {
			this.setState({
				feedbackDone: false,
				showFeedback: false,
				showFeedbackPopup: false,
			});
			return;
		}
		let payload = {
			id: 0,
			conversationId: this.state.conversationalId,
			messageId: msgId ? msgId : 0,
			botId: this.props.botID,
			rating: star,
			msgRating: msgRate ? msgRate : 0,
			feedBackText: comment,
		};
		fetch(
			portApiName +
				window['CHAT_URL'] +
				`/configuration/${this.props.tenantID}/feedBack`,
			{
				credentials: 'include',
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					'x-tenant-id': this.props.tenantID,
					Authorization: `Bearer ${this.state.bearerToken}`,
				},
				body: JSON.stringify(payload),
			}
		)
			.then((data) => data.json())
			.then((response) => {
				this.setState({
					showToaster: true,
				});
				setTimeout(() => {
					this.setState({
						showToaster: false,
					});
				}, 3000);
			});
		if (msgRate > 0) {
			this.state.chatMessages &&
				this.state.chatMessages.map((valdata: any) => {
					if (Object.keys(valdata).indexOf('messageId') > -1) {
						if (valdata.messageId === this.state.messageId) {
							return (valdata.thumbFilledUp = msgRate === 4 ? true : false);
						}
					}
				});
		}
	};

	handleOauthLogin(state, loginMessage) {
		let data = {
			responseElements: [
				{
					displayResponse:
						state === 'success'
							? loginMessage || 'You are loggedin, Welcome'
							: this.state.data.logoutMessage ||
							  "It seems like you couldn't be logged in, Can I help you with something else",
					responseType: 'SIMPLE',
				},
			],
			isOauthLoggedin: state === 'success' ? true : false,
			timeStamp: Date.now() + new Date().getTimezoneOffset() * 60 * 1000,
		};
		this.addServerResponse(data);
	}

	paintChatHistory(answers) {
		let answersArray = [];
		answers.forEach((ans) => {
			answersArray.push({
				message: ans.QUESTION,
				messageType: 'user',
				timeStamp: TimeUtil.getCurrentTime(
					new Date(
						new Date(ans.TIME).getTime() -
							new Date().getTimezoneOffset() * 60 * 1000
					)
				),
			});
			ans.ANSWERID = JSON.parse(ans.ANSWERID);
			/**
			 * Add an identifier when response comes from history
			 */
			const answer = ans.ANSWERID.responseElements.map((eachResponse) => ({
				...eachResponse,
				fromHistory: true,
			}));
			let disamb = [];

			if (Boolean(answer.disambQuestions) && answer.disambQuestions.length > 0)
				disamb = answer.disambQuestions;
			else if (
				Boolean(answer.relatedQuestions) &&
				answer.relatedQuestions.length > 0
			)
				disamb = answer.relatedQuestions;

			let errorFallbackLinks = answer.errorFallbackLinks || false;

			if (answer.NonComprehendFlag && errorFallbackLinks) {
				//Show quick links only when CouldNotComprehend
				errorFallbackLinks = true;
			}

			answersArray.push({
				message: answer,
				suggestions: disamb,
				timeStamp: TimeUtil.getCurrentTime(
					new Date(
						new Date(ans.TIME).getTime() -
							new Date().getTimezoneOffset() * 60 * 1000
					)
				),
				messageType: 'server',
				key: answer.key || answer.caId,
				errorFallbackLinks,
				searchStatus: answer.searchStatus,
				showFeedbackIcons: answer.showFeedbackIcons,
				workflowFlag: answer.workFlowflag,
				triggerOauth: answer.triggerOauth,
				promptLogin: answer.promptLogin,
				customInfos: [
					{ EntityName: answer.EntityName },
					{ entityID: answer.entityID },
					{ intentID: answer.intentID },
					{ intentName: answer.intentName },
					{ disambFlag: answer.disambflag },
				],
				extra: answer.extra,
				extraDisambInformation: {
					matchedEntity: answer.matchedEntity,
					matchedIntent: answer.matchedIntent,
					matchedQn: answer.matchedQn,
					entityHeirarchy: answer.entityHeirarchy,
					semantics: answer.semantics,
					variationMatched: answer.variationMatched,
					intentScore: answer.intentScore,
					intentNotMatch: answer.intentNotMatch,
					reverseIntentScore: answer.reverseIntentScore,
					reverseIntentNotMatch: answer.reverseIntentNotMatch,
					semanticsSequence: answer.semanticsSequence,
					entityInContext: answer.entityInContext,
				},
				suggestionChips: ans.ANSWERID.suggestions,
				messageId: answer.messageId,
				thumbFilledUp: answer.thumbFilledUp,
			});
		});

		this.setState(
			(prevState) => {
				return {
					chatMessages: [...prevState.chatMessages, ...answersArray],
				};
			},
			// () => this._scrollToBottom("Me")
			() => {
				this._scrollToBottom();
				this.disableActionLinks();
			}
		);
	}

	loadChatHistory() {
		DataAPI()
			.get('/ChatHistory')
			.then((response) => {
				//response.data.respo && JSON.parse(response.data.actualResponse).length > 0 ? this.paintChatHistory(JSON.parse(response.data.actualResponse)) : null
				if (response.data) this.paintChatHistory(response.data.response);
			})
			.catch((error) => {
				console.log(error);
			});
	}

	returnSaneURL(url) {
		return url.includes('http') ? url : window['BASE_URL'] + url;
	}
	encryptText = (text: string) => {
		let key = 'h7zbbhCs9c3L0NAMSNwourN9+rYaWMl8edZOyucs8Eg=';
		return btoa(CryptoJS.AES.encrypt(text, key).toString());
	};

	showCampaignBot = () => {
		if (this.state.data.isInsideCampaign) {
			console.log('inside campaign');
			this.setState({
				isBotVisible: true,
			});
		}
	};
	getValue = (data, name) => {
		let value = data.data.botConfig.filter((e) => e.configName == name)[0]
			.value;
		if (value == 'True' || value == 'False') {
			value = value.toLowerCase();
		}
		if (value == '[true]') {
			value = true;
		}
		if (value == '[false]') {
			value = false;
		}
		return value;
	};
	componentDidUpdate(_: Props, prevState: State) {
		if (
			!this.props.data.flyFishChangesReq &&
			this.state.isBotVisible &&
			prevState.currentLanguageCode !== this.state.currentLanguageCode
		) {
			this.clearSession(
				{
					isBotVisible: false, //changes bot
					showWelcomeScreen: false,
					botName: '',
					welcomeMessage: '',
					launcherPromptMessage: '',
					isLanguageListVisible: false,
				},
				() => {
					if (
						this.state.data.notification === 'true' &&
						!this.props.data.flyFishChangesReq
					) {
						this.getAllNotifications();
						this.getAllPolls();
						this.getAllSurveys();
					}
					Axios.get(
						window['BASE_URL'] +
							`/configuration/${this.props.tenantID}/bot/${this.props.botID}`,
						{
							headers: {
								'x-tenant-id': this.props.tenantID,
								Authorization: `Bearer ${this.state.bearerToken}`,
							},
						}
					).then((response) => {
						// let copyData = {
						// 	FAQcontextEnable: '',
						// 	thumbBorderColor: '',
						// 	actionHandlerClass: '',
						// 	thumbColor: this.getValue(
						// 		response.data,
						// 		'responseLevelFeedBackBckColor'
						// 	),
						// 	clientPlatform: '',
						// 	DISAMB_MSG_MULTIPLE_OPTIONS: '',
						// 	showBotIcon: this.getValue(response.data, 'showAvatar'),
						// 	defaultChitChatModuleDisabled: '',
						// 	disambWorkflowTriggerName: '',
						// 	primaryBGColor: '',
						// 	voiceSupport: '',
						// 	coverImageCheck: '',
						// 	quicklinks: this.getValue(response.data, 'quicklinks'),
						// 	languageSplitter: '',
						// 	handOffCount: '',
						// 	isAutoPopupEnabled: this.getValue(
						// 		response.data,
						// 		'autoPopupValue'
						// 	),
						// 	btnFillBackground: this.getValue(response.data, 'buttonBckColor'),
						// 	userLoginType: '',
						// 	linkValue: '',
						// 	PrefixNegativeEnabled: '',
						// 	quickLinksOnError: '',
						// 	btnFillColor: this.getValue(response.data, 'buttonTextColor'),
						// 	fontSize: this.getValue(response.data, 'fontSize'),
						// 	predictiveSearch: '',
						// 	schedulePublicAccess: '',
						// 	relatedQuestions: '',
						// 	headerTitle: response.data.data.name,
						// 	workFlowEndMessage: '',
						// 	oauthLogoutApi: '',
						// 	oauthClientId: '',
						// 	timeStampColor: this.getValue(response.data, 'timeStampBckColor'),
						// 	pageBackgroundColor: '',
						// 	disambThreshold: '',
						// 	terminateFlowonAPIfail: '',
						// 	optionsBackground: this.getValue(
						// 		response.data,
						// 		'optionsAndQuickLinksBckColor'
						// 	),
						// 	chitChatModuleDisabled: '',
						// 	apiSecretKey: '',
						// 	secondaryBGColor: '',
						// 	cncWorkflowTriggerName: '',
						// 	scheduleToDate: '',
						// 	handOffMessage: '',
						// 	isNotSureTemplateEnabled: '',
						// 	campaignWorkflowQuestion: '',
						// 	botDescription: 'Basic Components Testing Ad',
						// 	indexTimeUpdate: '',
						// 	backgroundColor: this.getValue(response.data, 'backgroundColor'),

						// 	userMsgColor:
						// 		this.getValue(response.data, 'colorMode') === 'dark'
						// 			? '#ffffff'
						// 			: JSON.parse(this.getValue(response.data, 'colorScale'))[0],
						// 	languages: '',
						// 	DISAMB_MSG_ONE_OPTION: '',
						// 	isBotDeployed: '',
						// 	welcomeMessage: this.getValue(response.data, 'welcomeMessage'),
						// 	clientCustomerCareEmail: 'demo@demo.com',
						// 	linkText: '',
						// 	clientProvider: '',
						// 	isBotFrozen: '',
						// 	clientBrand: 'CBRAND',
						// 	editOnRequestMessage: '',
						// 	agentSupport: '',
						// 	multipleIntentEnabled: '',
						// 	maskPIIData: 'true',
						// 	reversecertainThreshold: '',
						// 	tenantId: response.data.botConfig.tenantId,
						// 	googleTranslationAPIKey: '',
						// 	optionsBorder: this.getValue(
						// 		response.data,
						// 		'optionsAndQuickLinksBorderColor'
						// 	),
						// 	workflowChangeMessage: '',
						// 	chatBackgroundType: '',
						// 	optionsColor: this.getValue(
						// 		response.data,
						// 		'optionsAndQuickLinksTextColor'
						// 	),
						// 	oauthType: '',
						// 	botfailedMessage: '',
						// 	eB: response.data.botConfig.id,
						// 	clientTeam: '',
						// 	clientCustomerCareNumber: '0000000000',
						// 	font: '',
						// 	headerTextColor: '',
						// 	isBotPublic: true,
						// 	autoPopTime: this.getValue(response.data, 'autoPopupTime'),
						// 	clientNationality: 'India',
						// 	botImageCheck: '',
						// 	primaryColor: '',
						// 	HandsOffMessage: '',
						// 	timeStampBackground: this.getValue(
						// 		response.data,
						// 		'timeStampBckColor'
						// 	),
						// 	WorkFlowExitMessage: '',
						// 	similarityMatchingLogicEnabled: '',
						// 	notification: '',
						// 	PrefixNeutralEnabled: '',
						// 	tabTitle: '',
						// 	fontFamily: this.getValue(response.data, 'fontFamily'),
						// 	headerImage: this.getValue(response.data, 'headerImage'),
						// 	campaignWorkflowNodeId: '',
						// 	isMultiLingualEnabled: '',
						// 	userObjectApi: '',
						// 	coverImage:
						// 		'https://thumbor.forbes.com/thumbor/fit-in/900x510/https://www.forbes.com/advisor/wp-content/uploads/2022/03/retirement_checklist.jpeg.jpg',
						// 	scheduleFromDate: '',
						// 	prefixEnabled: '',
						// 	backgroundType: this.getValue(response.data, 'backgroundType'),
						// 	multiIntentMessage: '',
						// 	enableChatHistory: '',
						// 	userLoginEnabled: '',
						// 	accentColor: '',

						// 	userMsgBackground:
						// 		this.getValue(response.data, 'colorMode') === 'dark'
						// 			? this.getValue(response.data, 'selectedColor')
						// 			: JSON.parse(this.getValue(response.data, 'colorScale'))[6],
						// 	thumbBackground: this.getValue(
						// 		response.data,
						// 		'responseLevelFeedBackBckColor'
						// 	),
						// 	thumbBordercolor: this.getValue(
						// 		response.data,
						// 		'responseLevelFeedBackBorderColor'
						// 	),
						// 	srvMsgColor: JSON.parse(
						// 		this.getValue(response.data, 'colorScale')
						// 	)[0],
						// 	chatBackgroundColor: '',
						// 	defaultIcon: '',
						// 	userdetails: '',
						// 	jsonDelimiter: '',
						// 	botType: '',
						// 	isResponseLevelFeedbackEnabled: '',
						// 	headerType: '',
						// 	campaignWorkflow: '',
						// 	showCover: 'true',
						// 	themeConfig: '',
						// 	oauthAuthenticationApi: '',
						// 	StopWordsFlow: '',
						// 	isAutoLangDetectionEnabled: '',
						// 	botNameAsTitle: 'true',
						// 	srvMsgBackground: '#ffffff',
						// 	botConfigMl: '',
						// 	oauthTokenAPIUrl: '',
						// 	includeHandOffCountForDisamb: '',
						// 	loginSuccessMessage: '',
						// 	notSureTemplates: '[]',
						// 	headerStyle: this.getValue(response.data, 'headerIconPosition'),
						// 	backgroundImagePath: '',
						// 	headerColor: this.getValue(
						// 		response.data,
						// 		'headerTextAndIconColor'
						// 	),
						// 	allowOtherLang: '',
						// 	answerQuestionDelimiter: '',
						// 	scope: '',
						// 	botId: response.data.botConfig.id,
						// 	loginFailureMessage: '',
						// 	usrMsgColor: this.getValue(response.data, 'userMessageTextColor'),
						// 	certainAnswerChangeMessage: '',
						// 	serverMsgColor: this.getValue(
						// 		response.data,
						// 		'aiMessageTextColor'
						// 	),
						// 	headerContentType: this.getValue(
						// 		response.data,
						// 		'headerContentType'
						// 	),
						// 	popComment: '',
						// 	continueAfterAPI: '',
						// 	botImage: this.getValue(response.data, 'avatarImage').includes(
						// 		'http'
						// 	)
						// 		? this.getValue(response.data, 'avatarImage')
						// 		: window['BASE_URL'] +
						// 		  this.getValue(response.data, 'avatarImage'),
						// 	botName: response.data.botConfig.name,
						// 	speechSupport: '',
						// 	oauthClientSecret: '',
						// 	fileUploadAPI: '',
						// 	userObjectFields: '',
						// 	outlineBtnColor: this.getValue(
						// 		response.data,
						// 		'buttonTextAndOutlineColor'
						// 	),
						// 	baseURL: '',
						// 	botSkin: '',
						// 	headerContent: '',
						// 	logoImagePath: this.getValue(
						// 		response.data,
						// 		'avatarImage'
						// 	).includes('http')
						// 		? this.getValue(response.data, 'avatarImage')
						// 		: window['BASE_URL'] +
						// 		  this.getValue(response.data, 'avatarImage'),
						// 	certainThreshold: '',
						// 	botWelcomeMessage: this.getValue(response.data, 'welcomeMessage'),
						// 	headerBackground: this.getValue(
						// 		response.data,
						// 		'headerBackgroundColor'
						// 	),
						// 	usrMsgBackground: this.getValue(
						// 		response.data,
						// 		'userMessageBubbleColor'
						// 	),
						// 	logoImagePathForTitle: '',
						// 	serverMsgBackground: this.getValue(
						// 		response.data,
						// 		'aiMessageBubbleColor'
						// 	),
						// 	secondaryColor: '',
						// 	// colorScale: JSON.parse(this.getValue(response.data, 'colorScale')),
						// 	// colorMode: this.getValue(response.data, 'colorMode'),
						// 	// selectedColor: this.getValue(response.data, 'selectedColor'),
						// };
						this.setState({
							botName: response.data.botConfig.name,
							encryptbotId: response.data.botConfig.id,
							welcomeMessage:
								this.props.data &&
								this.props.data.dynamicMessages &&
								this.props.data.welcomeMessageType?.toLowerCase() === 'dynamic'
									? this.getDynamicWelcomeMessage(response.data.dynamicMessages)
									: response.data.botWelcomeMessage,
							launcherPromptMessage: this.getValue(
								response.data.botConfig,
								'aiLaunchPromptText'
							),
							data: { ...this.props.data, ...response.data },
							chatMessages: [
								{
									message: [
										{
											displayResponse:
												this.props.data &&
												this.props.data.dynamicMessages &&
												this.props.data.welcomeMessageType?.toLowerCase() ===
													'dynamic'
													? this.getDynamicWelcomeMessage(
															response.data.dynamicMessages
													  )
													: response.data.botWelcomeMessage,
											responseType: 'SIMPLE',
										},
									],
									timeStamp: TimeUtil.getCurrentTime(new Date()),
									key: null,
									messageType: 'server',
									customInfos: {},
									suggestionChips: [],
								},
							],
						});
					});
				}
			);
		}
		// this._scrollToBottom(true);
	}
	handleMessage(event) {
		// console.log('Received Message');
		// if (!process.env.REACT_APP_ALLOWED_ORIGINS.includes(event.origin)) {
		// 	console.warn('Origin not allowed:', event.origin);
		// 	return;
		// }

		const { searchText } = event.data;

		if (searchText) {
			// console.log('Received searchText:', searchText);
			searchText && this.handleSubmit(searchText);
		} else {
			// console.log('No searchText found in the message');
		}
		// console.log('listening_FF', event.data);
		if (event.data === 'startTrackingClicks') {
			document.addEventListener('click', function (event) {
				console.log('clicked_FF');
				if (event.target instanceof HTMLElement) {
					window.parent.postMessage(
						{
							type: 'click',
							target: (event.target as HTMLElement).textContent,
						},
						'*'
					);
				}
			});
		}
	}
	componentDidMount() {
		this.clearSessionStorageData();
		window.addEventListener('message', this.handleMessage);
		if (
			window.location.protocol === 'https:' ||
			window.location.origin.indexOf('http://localhost:3000') > -1
		) {
			portApiName = 'https://';
			socketName = 'wss';
		} else {
			portApiName = 'http://'; //remove s from this line
			socketName = 'ws';
		}
		if (this.props.tenantID) {
			saveStateSession('tenantID', this.props.tenantID);
			saveStateSession('token', this.state.bearerToken);
			saveStateSession('botID', this.props.botID);
		}
		if (
			!this.state.data.isInsideKampsta &&
			this.state.data.agentSupport &&
			this.state.data.agentSupport === 'true'
		) {
			if (
				this.takeoverSocket &&
				this.takeoverSocket.readyState === WebSocket.OPEN
			) {
				this.takeoverSocket.close(
					1000,
					'wsagentintervention Socket closing from UI'
				);

				console.log('socket closing on AI close after timer');
			}

			if (this.state.wsendpointSocketStatus !== 'closed') {
				this.chatSocket && this.chatSocket.close();
			}
		}
		if (
			this.state.data.userLoginEnabled &&
			this.state.data.userLoginEnabled === 'true' &&
			this.state.data.authenticationMechanism &&
			this.state.data.authenticationMechanism === 'sso'
		) {
			this.SSOAuthentication();
		}
		if (
			this.state.data.enableChatHistory &&
			JSON.parse(this.state.data.enableChatHistory)
		)
			this.loadChatHistory();

		if (
			this.state.data.isAutoPopupEnabled &&
			(this.state.data.isAutoPopupEnabled === 'true' ||
				this.state.data.isAutoPopupEnabled === true) &&
			this.state.data.autoPopTime != ''
		) {
			var tmRef = window.setTimeout(() => {
				if (!this.state.isBotVisible) {
					this.showBot(); //changed bot
					window.clearTimeout(tmRef);
				}
			}, +this.state.data.autoPopTime * 1000);
		}
		window['autosubmit'] = this.handleSubmit.bind(this);
		window['toggleMsgFeed'] = this.toggleMessageFeedbackModal.bind(this);
		window['popUpSnackBar'] = this.popUpSnackBar.bind(this);
		window['setOtherToaster'] = this.setOtherToaster.bind(this);
		window['internalFeedbackBanner'] = this.internalFeedbackBanner.bind(this);
		window['clearSession'] = this.clearSession.bind(this);
		window['openChatbot'] = this.showBot.bind(this);
		window['hideBot'] = this.hideBot.bind(this);
		this.showCampaignBot();

		/**
		 * Handle clicks on anchor tags
		 */
		const elem = document.querySelector('.sf-chatbot');
		if (elem) {
			elem.addEventListener('click', (event) => {
				const target = event.target as any;
				if (target.nodeName === 'A') {
					const href = target.href;
					if (target.href && target.href.indexOf('autosubmit') > -1) {
						target.removeAttribute('target');
					}
					anchorTagClickHandler(href, (data) => {
						event.preventDefault();
						this.handleSubmit(data, {});
					});
				}
			});
		}
		/**
		 * Create customized class
		 */
		const customStyles = `
.sf-primary-bg-color {
background-color: ${this.state.data.primaryColor}
}
`;
		const styleTag = document.createElement('style');
		styleTag.innerHTML = customStyles;
		styleTag.setAttribute('nonce', '0xf08c98caf1fd82e8cea9825dbff04fd0');
		document.head.appendChild(styleTag);
		/**
		 * Call notification, polls api if enabled from config
		 */
		if (
			this.state.data.notification === 'true' &&
			!this.props.data.flyFishChangesReq
		) {
			this.getAllNotifications();
			this.getAllPolls();
			this.getAllSurveys();
		}

		/**
		 * Trigger workflow if this is campaign bot and workflow
		 * trigger is enabled
		 */
		if (
			this.state.data.campaignWorkflow === 'true' &&
			this.state.data.isInsideCampaign
		) {
			this.handleSubmit(this.state.data.campaignWorkflowQuestion, {});
		}
		const isLoadedFromAgentDashboard =
			window.location.href.indexOf('source=agent') > -1;
		// if (isLoadedFromAgentDashboard) {
		// 	this.setState({
		// 		isLoadedFromAgentDashboard,
		// 		isBotVisible: true,
		// 	});
		// 	/**
		// 	 * Listen to message events from agent dashboard
		// 	 */
		// 	// 	window.addEventListener('message', this.handleMessageFromAgentDashboard);
		// 	window.parent.postMessage('loaded', '*');
		// }
		if (
			!isLoadedFromAgentDashboard &&
			this.props.data.notification === 'true'
		) {
			// this.getAllNotifications();
			// this.getAllPolls();
		}
		// if (
		//   !isLoadedFromAgentDashboard &&
		//   this.props.data.enableChatHistory &&
		//   JSON.parse(this.props.data.enableChatHistory
		//     )
		// )

		if (!isLoadedFromAgentDashboard) {
			// this.loadChatHistory();
			this.clearSession();
		}

		if (
			window.location.href.indexOf('env') > -1 &&
			!this.state.data.isInsideKampsta
		) {
			this.clearSession();
		}
		/**
		 * Load Available Languages
		 */

		if (truthyOrFalsy(this.props.data.isMultiLingualEnabled)) {
			this.getAvailableLanguage();
			this.setState({
				isLanguageListVisible:
					this.props.data.showLangModal === 'true' ? true : false,
			});
		}

		window.addEventListener('online', () =>
			this.networkStatusChangeHandler(true)
		);
		window.addEventListener('offline', () =>
			this.networkStatusChangeHandler(false)
		);

		this.setDefaultLanguage(
			this.props.data.languages,
			this.props.data.defaultLanguage
		);
		// if (this.props.data.flyFishChangesReq) {
		// 	Axios.post(window['BASE_URL'] + '/session/add', {
		// 		botId: Number(this.props.botID),
		// 	});
		// }
	}
	componentWillUnmount() {
		document.addEventListener('sessionexpire', this.expiryListener);
		window.removeEventListener('beforeunload', this.handleWindowBeforeUnload);
		// this.clearSession();
		// this.setupBeforeUnloadListener();
		// window.removeEventListener("beforeunload", this.clearSessionApi);
	}

	setupBeforeUnloadListener = () => {
		const isLoadedFromAgentDashboard =
			window.location.href.indexOf('source=agent') > -1;
		window.addEventListener('beforeunload', (ev) => {
			ev.preventDefault();
			if (!isLoadedFromAgentDashboard && !this.props.data.isInsideKampsta) {
				this.clearSession();
			}
			return '';
		});
	};

	networkStatusChangeHandler = (isConnectedToNetwork: boolean) => {
		this.setState(
			{
				toasterBodyIdentifier: ToasterIdentifier.Network,
				isConnectedToNetwork,
			},
			() => {
				setTimeout(() => {
					if (isConnectedToNetwork) {
						this.closeToaster();
					}
				}, 3000);
			}
		);
	};

	SSOAuthentication = () => {
		fetch(`${window['BASE_URL']}/GenericChatBot/ssoUserObject`, {
			credentials: 'include',
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				version: 'prod',
				botId: this.state.data.eB,
			}),
		});
	};

	setOtherToaster = (message, buttons = [], showIcon = false) => {
		let scrollableBody = !this.state.isOverlayVisible
			? document.querySelector('.sf-chatbody')
			: document.querySelector('#sfOffersRoll');
		this.setState(
			{
				toasterBodyIdentifier: ToasterIdentifier.Other,
				toasterMessageTemplate: {
					message,
					buttons,
					showIcon,
				},
				lastScroll: scrollableBody.scrollTop,
			},
			() => {
				scrollableBody.scrollTop = this.state.lastScroll;
				// setTimeout(() => {
				//   if (buttons === []) {
				//     this.closeToaster();
				//   }
				// }, 3000);
			}
		);
	};

	closeToaster = () => {
		this.setState({
			toasterBodyIdentifier: ToasterIdentifier.None,
			toasterMessageTemplate: {
				message: '',
				buttons: [],
				showIcon: false,
			},
		});
	};

	getAvailableLanguage = () => {
		return DataAPI()
			.post('/availableLanguage')
			.then((response: any) => {
				let data = response.data;
				data.availableLanguage.push({ isocode: 'en', language: 'English' });
				this.setState({
					languageCodes: data.availableLanguage.reduce(
						(acc, elem) => ({ ...acc, [elem.isocode]: elem.language }),
						{}
					),
				});
			});
	};
	showBot() {
		if (this.state.chatMessages.length === 0) {
			this.chatSocket && this.chatSocket.close();
			if (
				this.takeoverSocket &&
				this.takeoverSocket.readyState === WebSocket.OPEN
			) {
				this.takeoverSocket.close(
					1000,
					'wsagentintervention Socket closing from UI'
				);

				console.log('socket closing on bot close');
			}
		}

		if (this.state.chatMessages.length === 0) {
			this.chatSocket && this.chatSocket.close();
			if (
				this.takeoverSocket &&
				this.takeoverSocket.readyState === WebSocket.OPEN
			) {
				this.takeoverSocket.close(
					1000,
					'wsagentintervention Socket closing from UI'
				);

				console.log('socket closing on bot close');
			}
		}

		var chatbot = document.querySelector('.sf-chatbot');
		chatbot.classList.remove('hide-bot');
		chatbot.classList.add('show-bot');

		this.setState({ isBotVisible: true }, () => {
			if (this.state.chatMessages.length > 2) {
				document.querySelector('.sf-chatbody').scrollTop =
					this.state.lastScroll;
			} else if (this.state.isOverlayVisible) {
				document.querySelector('#sfOffersRoll').scrollTop =
					this.state.lastScroll;
			}
		});
		if (this.state.sessionCleared) {
			this.setState({
				isLanguageListVisible:
					this.props.data.showLangModal === 'true' ? true : false,
			});
		}
		// this.checkTimer();
		// this.checkApiUserToken();
	}
	updateLanguageCode = (langCode: string) => {
		if (this.state.currentLanguageCode === langCode) {
			return;
		}

		/**
		 * Welcome message is always there
		 */
		if (
			this.state.chatMessages.length > 1 &&
			this.state.currentLanguageCode !== langCode
		) {
			this.setState({ targetLangCode: langCode, showLangConfirmation: true });
		} else {
			this.languageConfirm(langCode);
		}
	};
	toggleLang = (close = false) => {
		let items = Object.values(this.state.languageCodes);
		if (close) {
			this.setState({
				isModalVisible: false,
				showLangConfirmation: false,
				isLanguageListVisible: false,
				sessionCleared: false,
			});
		} else {
			this.setState({
				isModalVisible: true,
				isLanguageListVisible: true,
				simplifiedLangCodes: items,
			});
		}
	};
	languageConfirm = (langCode?) => {
		this.setState(
			(state) => ({
				currentLanguageCode: state.targetLangCode
					? state.targetLangCode
					: langCode,
			}),
			() => {
				this.toggleLang(true);
			}
		);
	};
	handleSessionTimer = (val: boolean) => {
		if (val === true) {
			window.location.reload();
		}
	};
	toggleMessageFeedbackModal = (
		val,
		data = null,
		cb: Function = () => {},
		prevVal
	) => {
		this.setState((state) => ({
			isModalVisible: !state.isModalVisible,
			messageFeedbackComment: data,
			messageFeedbackRating: val,
			messageFeedbackCallback: cb,
			messageFeedbackPrevVal: prevVal,
		}));
	};
	setDefaultLanguage = (availableLanguage: string, defaultLanguage: string) => {
		if (defaultLanguage && defaultLanguage !== '') {
			availableLanguage.split(',').forEach((elem: string) => {
				if (elem.trim() === defaultLanguage) {
					this.setState({
						currentLanguageCode: defaultLanguage,
					});
					return;
				}
			});
		}
	};
	restartSession = () => {
		var date = new Date();
		var timestamp = Math.floor(date.getTime() / 1000.0);
		var usertenantID = this.encryptText(`${this.props.tenantID}:${timestamp}`);
		console.log(usertenantID);
		const endpoint =
			window.location.origin.indexOf('localhost') > -1 ||
			window.location.origin.indexOf('https://dev.flyfish.ai') > -1
				? window['BASE_URL']
				: window.location.origin.indexOf('uat.flyfish.ai') > -1
				? 'https://uat.flyfish.ai'
				: window.location.origin.indexOf('preprod.flyfish.ai') > -1
				? 'https://preprod.flyfish.ai'
				: window['BASE_URL'];
		Axios.post(
			endpoint + `/authentication/anonynousLogin`,
			{
				name: 'anonymous',
				email: 'anonymousEmail',
				teamId: usertenantID,
			},
			{
				headers: {
					'x-tenant-id': this.props.tenantID,
				},
			}
		).then((response) => {
			let token = response.data.data.token;
			this.setState({
				bearerToken: token,
			});
			this.state.userQuery &&
				this.handleSubmit(this.state.userQuery, '', { isHidden: true });

			let sessionIDFORM = response.data.data.createdTime;
		});
	};

	handleSelectedProduct = (data) => {
		this.setState({
			selectedProduct: data,
		});
	};
	handleLogo = (logoPath: string) => {
		if (logoPath.length > 0) return logoPath;
		else return botLogo;
	};

	changeScreen(val: string, feedbackval?: boolean) {
		this.setState({
			currentScreen: val,
			showFeedbackPopup: feedbackval,
		});
	}
	disableGetInTouch = () => {
		this.setState({
			disableGetInTouch: true,
		});
	};
	disableMandatory = () => {
		this.setState({
			mandatoryCollection: false,
			detailCollection: false,
		});
	};

	HideWelcomeScreen(bool: boolean) {
		this.setState(
			{
				showWelcomeScreen: bool,
			},
			() => {
				if (this.state.showWelcomeScreen) {
					this.setState({
						conversationalId: 0,
						// chatMessages: [],
						chatMessages: [
							{
								message: [
									{
										displayResponse: this.state.welcomeMessage,
										responseType: 'SIMPLE',
									},
								],
								timeStamp: TimeUtil.getCurrentTime(new Date()),
								key: null,
								messageType: 'server',
								customInfos: {},
								suggestionChips: [],
							},
						],
					});
				}
			}
		);
	}
	render() {
		let headerWidth;
		if (this.props.data.flyFishChangesReq) {
			headerWidth = styleVars.getPropertyValue('--botWidth');
		}

		return (
			<div
				id='sfChatBotContainer'
				className={
					this.state.data.hideChatBot
						? 'hidden'
						: this.props.data.clientDetails.applyCustomTheme
						? `client-specific-theme-${this.props.data.clientDetails.clientName}`
						: ''
				}
			>
				{this.props.data.selectedTheme == 'E-commerce' ? (
					<>
						<InternationalizationContext.Provider
							value={{
								currentLanguage: 'en',
								data: LabelInternationalization,
							}}
						>
							<EcomTheme
								handleToaster={this.handleToaster}
								tenantId={this.props.tenantID}
								botId={this.props.botID}
								token={this.state.bearerToken}
								country={this.state.currentCountry}
								secondAPI={this.state.secondAPI}
								encryptText={this.encryptText.bind(this)}
								colorMode={this.props.data.colorMode}
								changeToken={(token) => {
									this.setState({ bearerToken: token });
								}}
								popUpSnackBar={this.popUpSnackBar}
								enableStyleAdvisor={this.props.data.enableStyleAdvisor}
								advisorTitle={this.props.data.advisorTitle}
								enableTrendingSearch={this.props.data.enableTrendingSearch}
								staticDetailsURL={this.props.data.staticDetailsURL}
								enableIntent={this.props.data.enableIntent}
							/>
						</InternationalizationContext.Provider>
						{this.state.showToaster && (
							<>
								<div
									style={{
										width: '100%',
										display: 'flex',
										justifyContent: 'center',
									}}
								>
									<TOASTER
										className='ff-toaster ff-chatbot-caption ff-ecom'
										colorMode={this.props.data.colorMode}
									>
										Thanks for your feedback
									</TOASTER>
								</div>
							</>
						)}
					</>
				) : this.props.data.selectedTheme === 'Ecom New Search' ? (
					<>
						<InternationalizationContext.Provider
							value={{
								currentLanguage: 'en',
								data: LabelInternationalization,
							}}
						>
							<EcomNewSearch
								handleToaster={this.handleToaster}
								tenantId={this.props.tenantID}
								botId={this.props.botID}
								token={this.state.bearerToken}
								country={this.state.currentCountry}
								secondAPI={this.state.secondAPI}
								encryptText={this.encryptText.bind(this)}
								colorMode={this.props.data.colorMode}
								changeToken={(token) => {
									this.setState({ bearerToken: token });
								}}
								popUpSnackBar={this.popUpSnackBar}
								enableStyleAdvisor={this.props.data.enableStyleAdvisor}
								advisorTitle={this.props.data.advisorTitle}
							/>
						</InternationalizationContext.Provider>
						{this.state.showToaster && (
							<>
								<div
									style={{
										width: '100%',
										display: 'flex',
										justifyContent: 'center',
									}}
								>
									<TOASTER
										className='ff-toaster ff-chatbot-caption ff-ecom'
										colorMode={this.props.data.colorMode}
									>
										Thanks for your feedback
									</TOASTER>
								</div>
							</>
						)}
					</>
				) : this.props.data.selectedTheme == 'E-commerce Search' ? (
					<>
						<InternationalizationContext.Provider
							value={{
								currentLanguage: 'en',
								data: LabelInternationalization,
							}}
						>
							<EcomSearch
								ecomSearchDetails={JSON.parse(
									this.props.data.ecomSearchDetails
								)}
								ecomSearchVertical={this.props.data.ecomSearchVertical.toLowerCase()}
								handleToaster={this.handleToaster}
								tenantId={this.props.tenantID}
								botId={this.props.botID}
								token={this.state.bearerToken}
								country={this.state.currentCountry}
								secondAPI={this.state.secondAPI}
								encryptText={this.encryptText.bind(this)}
								colorMode={this.props.data.colorMode}
								changeToken={(token) => {
									this.setState({ bearerToken: token });
								}}
								popUpSnackBar={this.popUpSnackBar}
								enableStyleAdvisor={
									this.props.data.enableStyleAdvisor === 'true' ? true : false
								}
								advisorTitle={this.props.data.advisorTitle}
								enableTrendingSearch={this.props.data.enableTrendingSearch}
								staticDetailsURL={this.props.data.staticDetailsURL}
								enableIntent={this.props.data.enableIntent}
								product_count={this.props.data.product_count_per_page}
								enableSpeech={
									this.props.data.searchEnabled.includes('voice') ? true : false
								}
								enableImageUpload={
									this.props.data.searchEnabled.includes('image') ? true : false
								}
								enablePDP={this.props.data.enablePDP === 'true' ? true : false}
							/>
						</InternationalizationContext.Provider>
						{this.state.showToaster && (
							<>
								<div
									style={{
										width: '100%',
										display: 'flex',
										justifyContent: 'center',
									}}
								>
									<TOASTER
										className='ff-toaster ff-chatbot-caption ff-ecom'
										colorMode={this.props.data.colorMode}
									>
										Thanks for your feedback
									</TOASTER>
								</div>
							</>
						)}
					</>
				) : (
					<InternationalizationContext.Provider
						value={{
							currentLanguage: this.state.currentLanguageCode,
							data: LabelInternationalization,
						}}
					>
						<SFIconStyles styles={this.state.data} />

						<BotIcon
							isChatStarted={this.state.isChatStarted}
							isBotVisible={this.state.isBotVisible}
							logoImagePath={this.handleLogo(this.state.data.logoImagePath)}
							returnSaneURL={this.returnSaneURL}
							showBot={this.showBot.bind(this)}
							data={this.state.data}
							launcherPromptMessage={this.state.launcherPromptMessage}
							isChatInputDisabled={this.state.isChatInputDisabled}
							isConnectedToNetwork={this.state.isConnectedToNetwork}
							langCode={this.state.currentLanguageCode}
						/>

						<AppStyles styles={this.state.data} />
						<ChatStyles styles={this.state.data} />
						<div
							className='open-chat-bot'
							onClick={() => {
								this.setState(
									{
										isBotVisible: false,
										conversationalId: 0,
										botName: this.state.botName,
										welcomeMessage: this.state.welcomeMessage,
										launcherPromptMessage: this.state.launcherPromptMessage,
										showWelcomeScreen: false,
										chatMessages: [
											{
												message: [
													{
														displayResponse: this.state.welcomeMessage,
														responseType: 'SIMPLE',
													},
												],
												timeStamp: TimeUtil.getCurrentTime(new Date()),
												key: null,
												messageType: 'server',
												customInfos: {},
												suggestionChips: [],
											},
										],
										isLanguageListVisible: false,
									},
									() => {}
								);
							}}
							style={{
								position: 'fixed',
								right: '18px',
								bottom: '4px',
								display: this.state.isBotVisible ? 'block' : 'none',
								cursor: 'pointer',
							}}
						>
							{/* <CloseBotArrow /> */}
						</div>

						<div
							role='region'
							aria-label={TString({
								labelName: 'chatWindowOpenLabel',
								langCode: this.state.currentLanguageCode,
								fromClass: true,
							})}
							className={`sf-chatbot ${
								this.state.data.isInsideCampaign
									? 'campaign-bot'
									: this.state.isLoadedFromAgentDashboard
									? 'sf-chatbot-full-width from-dashboard'
									: ''
							}`}
							style={{
								width:
									!this.props.data.isInsideCampaign &&
									!this.props.data.isInsideKampsta
										? headerWidth + 'px'
										: '',
								display: this.state.isBotVisible ? 'block' : 'none',
								// bottom: this.state.isBotVisible ? '55px' : '0px',
								borderRadius: '24px',
							}}
						>
							{this.state.isLoadedFromAgentDashboard ? null : (
								<Header
									mandatoryCollection={this.state.mandatoryCollection}
									detailCollection={this.state.detailCollection}
									isChatStarted={this.state.isChatStarted}
									botName={this.state.botName}
									sessionComplete={this.state.isBotSessionTimeout}
									toggleOverlay={this.toggleOverlay.bind(this)}
									toggleChatBody={this.toggleChatBody.bind(this)}
									isChatBodyVisible={this.state.isChatBodyVisible}
									hideBot={this.hideBot.bind(this)}
									handleModalToggle={this.handleModalToggle.bind(this)}
									data={this.state.data}
									redirectToExternalBot={this.redirectToExternalBot}
									theme={this.state.selectedTheme}
									isUserLoggedin={this.state.isUserLoggedin}
									triggerLogout={this.triggerLogout.bind(this)}
									toShowRedDot={
										(this.state.notifications.length > 0 ||
											this.state.polls.length > 0) &&
										this.state.disableDotOnceClick
											? true
											: false
									}
									isOverlayVisible={this.state.isOverlayVisible}
									headerExternalTheme={
										this.state.data.isInsideCampaign
											? false
											: this.state.data.headerStyle === 'external'
									}
									feedbackDone={this.state.feedbackDone}
									toggleLang={this.toggleLang.bind(this)}
									isModalVisible={this.state.isModalVisible}
									restartFlow={this.restartFlow.bind(this)}
									toLang={this.state.targetLangCode}
									isConnectedToNetwork={this.state.isConnectedToNetwork}
									disableRefresh={this.state.disableRefresh}
									flyFishChangesReq={this.props.data.flyFishChangesReq}
									isInsideKampsta={this.props.data.isInsideKampsta}
									channel={this.state.channel}
									HideWelcomeScreen={this.HideWelcomeScreen}
									RefreshSession={this.RefreshSession}
									changeScreen={this.changeScreen}
									currentScreen={this.state.currentScreen}
									// headerType={'image'} //temp
								/>
							)}
							{this.state.isBotVisible ? (
								<React.Suspense fallback={<div>Loading...</div>}>
									<MatchedNodeContext.Provider
										value={{
											taskId: this.state.taskId,
											workflowId: this.state.workflowId,
											botId: +this.props.botID,
										}}
									>
										<CurrentLanguageContext.Provider
											value={{
												languageCode: this.state.currentLanguageCode,
												updateLanguageCode: this.updateLanguageCode,
											}}
										>
											<LanguageContext.Provider
												value={this.state.languageCodes}
											>
												{/* {this.state.isWaitingForAgent ||
												this.state.isConnectedWithAgent ||
												this.state.isCancellingTransfer ||
												this.state.isDisconnectingFromAgent ? (
												<>
													<Toaster>
														{this.state.isWaitingForAgent &&
															this.state.isChatBodyVisible &&
															!this.state.hasSessionExpired &&
															this.state.connectSocketAfterUserDetails ? (
															<WaitingForAgent
																estimatedWaitTime='Less than a min'
																positionInQueue={this.state.positionInQueue}
																onCancel={this.stopWaitingForAgent}
															/>
														) : null}
														{this.state.isConnectedWithAgent &&
															!this.state.isDisconnectingFromAgent &&
															this.state.isChatBodyVisible &&
															!this.state.hasSessionExpired ? (
															<Chatting
																onDisconnect={() => {
																	this.setState({
																		isDisconnectingFromAgent: true,
																		// showDisconnectMsg: true,
																	});
																}}
															/>
														) : null}
														{this.state.isCancellingTransfer ? (
															<CancelTransfer
																onCancel={this.handleTransferCancel}
																onContinue={this.handleContinueWaiting}
															/>
														) : null}
														{this.state.isDisconnectingFromAgent ? (
															<DisconnectingFromAgent
																agentName={this.state.liveAgentName}
																onContinueChatting={() =>
																	this.setState({
																		isDisconnectingFromAgent: false,
																		isConnectedWithAgent: true,
																	})
																}
																onDisconnect={() => {
																	this.setState(
																		{
																			showDisconnectMsg: true,
																		},
																		() => {
																			this.disconnectFromAgent(true);
																		}
																	);
																}}
															/>
														) : null}
													</Toaster>
												</>
											) : null} */}
												{this.state.showToaster && (
													<>
														<div
															style={{
																width: '100%',
																display: 'flex',
																justifyContent: 'center',
															}}
														>
															<TOASTER
																className='ff-toaster ff-chatbot-caption'
																colorMode={this.props.data.colorMode}
															>
																Thanks for your feedback
															</TOASTER>
														</div>
													</>
												)}
												<ChatBody
													voiceText={this.state.voiceText}
													staticDetailsURL={this.props.data.staticDetailsURL}
													enableStyleAdvisor={
														this.props.data.enableStyleAdvisor
													}
													advisorTitle={this.props.data.advisorTitle}
													userQuery={this.state.userQuery}
													conversationalId={this.state.conversationalId}
													cartExist={this.state.cartExist}
													cartId={this.state.cartId}
													selectedButton={this.props.data.selectedButton}
													showOnHover={this.props.data.showOnHover}
													selectedTheme={this.props.data.selectedTheme}
													selectedColor={this.props.data.selectedColor}
													recommendationHeading={
														this.props.data.recommendationHeading
													}
													colorScale={this.props.colorScale}
													getProductDescription={this.getProductDescription.bind(
														this
													)}
													reason={this.state.reason}
													handleSelectedProduct={this.handleSelectedProduct.bind(
														this
													)}
													productCarousel={this.state.productCarousel}
													showForm={this.state.showForm}
													enableGetInTouch={
														this.props.data.additionalsettingDetailsCollection.toLowerCase() ==
														'true'
															? true
															: false
													}
													handleDisableGetInTouch={this.disableGetInTouch.bind(
														this
													)}
													disableGetInTouch={this.state.disableGetInTouch}
													disableMandatory={this.disableMandatory.bind(this)}
													mandatoryCollection={this.state.mandatoryCollection}
													detailCollection={this.state.detailCollection}
													formChatInputHidden={this.state.formChatInputHidden}
													paymentStatus={this.state.paymentStatus}
													handlePaymentStatus={this.handlePaymentStatus.bind(
														this
													)}
													lang={this.state.currentLanguageCode}
													EbotId={this.props.eB}
													getCartId={this.getCartId.bind(this)}
													getProductDetails={this.getProductDetails.bind(this)}
													createCart={this.createCart.bind(this)}
													makePayment={this.makePayment.bind(this)}
													getLoader={this.getLoader}
													langCode={this.state.currentLanguageCode}
													boxRef={this.box}
													popUpSnackBar={this.popUpSnackBar}
													chatMessages={this.state.chatMessages}
													isChatBodyVisible={this.state.isChatBodyVisible}
													chatInput={this.state.chatInput}
													handleInput={this.handleInput.bind(this)}
													handleKeyUp={this.handleKeyUp.bind(this)}
													handleSubmit={this.handleSubmit.bind(this)}
													quickLinks={this.props.botQuickLinks}
													isSpeech={this.state.isSpeech}
													data={this.state.data}
													handleFocus={this.handleFocus.bind(this)}
													predSearchToggle={this.state.predSearchToggle}
													predSearchResponse={this.state.predSearchResponse}
													togglePredSearch={this.hidePredSearch.bind(this)}
													toggleLoginScreen={this.toggleLoginScreen.bind(this)}
													isChatInputHidden={this.state.isChatInputHidden}
													isdisableInput={this.props.data.isdisableInput}
													assignPredSearchQues={this.assignPredSearchQues.bind(
														this
													)}
													theme={this.state.selectedTheme}
													showWelcomeScreen={false}
													isChatInputDisabled={this.state.isChatInputDisabled}
													isCampaignWorkflowTriggered={
														this.state.data.campaignWorkflow === 'true' &&
														this.state.data.isInsideCampaign
													}
													stopSpeaking={this.stopSpeaking}
													toggleSpeakingFunctionality={
														this.toggleSpeakingFunctionality
													}
													suggestions={this.state.suggestions}
													welcomeMessage={this.state.welcomeMessage}
													setLangListVisibility={this.setLangListVisibility}
													headerExternalTheme={
														this.state.data.isInsideCampaign
															? false
															: this.state.data.headerStyle === 'external'
													}
													handleModalToggle={this.handleModalToggle.bind(this)}
													snackBarMessage={this.state.snackBarMessage}
													toasterBodyIdentifier={
														this.state.toasterBodyIdentifier
													}
													isConnectedToNetwork={this.state.isConnectedToNetwork}
													toasterMessageTemplate={
														this.state.toasterMessageTemplate
													}
													toggleOverlay={this.toggleOverlay.bind(this)}
													isOverlayVisible={this.state.isOverlayVisible}
													notifications={this.state.notifications}
													closeNotification={this.closeNotification.bind(this)}
													surveys={this.state.surveys}
													surveySubmit={this.surveySubmit.bind(this)}
													polls={this.state.polls}
													pollSubmit={this.pollSubmit.bind(this)}
													voiceResponse={this.state.voiceResponse}
													flyFishChangesReq={this.props.data.flyFishChangesReq}
													channel={this.state.channel}
													addUserResponse={this.addUserResponse}
													addServerMessage={this.addServerMessage}
													toggleLang={this.toggleLang.bind(this)}
													HideWelcomeScreen={this.HideWelcomeScreen}
													changeScreen={this.changeScreen}
													currentScreen={this.state.currentScreen}
													logoImagePath={this.handleLogo(
														this.state.data.logoImagePath
													)}
													workflowData={this.props.data}
													tenantId={this.props.tenantID}
													botId={this.props.botID}
													conversationId={this.state.conversationalId}
													token={this.state.bearerToken}
													submitFeedback={this.submitFeedback.bind(this)}
													showFeedbackPopup={this.state.showFeedbackPopup}
													botClosingModal={this.state.botClosingModal}
													openThumbsPopup={this.openThumbsPopup.bind(this)}
													thumbFilledUp={this.state.thumbFilledUp}
													enableVoiceModal={this.enableVoice.bind(this)}
												/>
											</LanguageContext.Provider>
										</CurrentLanguageContext.Provider>
									</MatchedNodeContext.Provider>
								</React.Suspense>
							) : null}
							{this.state.showLoginScreen ? (
								<React.Suspense fallback={<div>Loading...</div>}>
									<LoginScreen
										toggleLoginScreen={this.toggleLoginScreen.bind(this)}
										oauthURL={this.state.oauthURL}
										handleSubmit={this.handleSubmit.bind(this)}
										handleOauthLogin={this.handleOauthLogin.bind(this)}
										setLogoutMessage={this.setLogoutMessage.bind(this)}
										botID={this.props.botID}
									/>
								</React.Suspense>
							) : null}

							{this.state.isModalVisible ||
							(this.state.isLanguageListVisible &&
								Object.keys(this.state.languageCodes).length) ? (
								<React.Suspense fallback={<div>Loading...</div>}>
									<SFModal isModalVisible={this.state.isModalVisible}>
										{this.state.isBotSessionTimeout &&
										!this.state.isConnectedWithAgent ? (
											<SessionTimeout
												restartSession={this.restartSession.bind(this)}
												clearSession={this.clearSession}
												handleModalToggle={this.toggleSessionTimeoutPopUp}
												data={this.state.data}
												flyFishChangesReq={this.props.data.flyFishChangesReq}
												cartExist={this.state.cartExist}
												hideMonacoCart={this.hideMonacoCart}
												selectedTheme={this.state.selectedTheme}
											/>
										) : this.state.isLanguageListVisible ? (
											<LangModal
												language1={this.state.data.languages}
												langcodes={this.state.languageCodes}
												changeLang={this.updateLanguageCode.bind(this)}
												onClose={this.toggleLang.bind(this, true)}
												currentLang={this.state.currentLanguageCode}
												showLangConfirmation={this.state.showLangConfirmation}
												toLang={this.state.targetLangCode}
												onConfirm={() => this.languageConfirm()}
												detailedLanguages={this.props.data.detailedLanguages}
											/>
										) : this.state.messageFeedbackComment !== null ? (
											<MessageFeedbackComment
												msgKey={this.state.messageFeedbackComment}
												data={this.state.data}
												popUpSnackBar={this.popUpSnackBar}
												selectedRating={this.state.messageFeedbackRating}
												messageFeedbackCallback={
													this.state.messageFeedbackCallback
												}
												messageFeedbackPrevVal={
													this.state.messageFeedbackPrevVal
												}
												submitFeedback={this.submitFeedback.bind(this)}
												thumbFilledUp={this.state.thumbFilledUp}
												thumbFilledDown={this.state.thumbFilledDown}
												messageId={this.state.messageId}
												colorMode={this.props.data.colorMode}
												openThumbsPopup={this.openThumbsPopup.bind(this)}
											/>
										) : this.state.showLoader ? (
											<LoaderModal />
										) : (
											<ClearSessionOverlay
												handleModalToggle={this.handleModalToggle.bind(this)}
												submitFeedback={this.submitFeedback.bind(this)}
												showfeedback={this.state.showFeedback}
												botClosingModal={this.state.botClosingModal}
											/>
										)}
									</SFModal>
								</React.Suspense>
							) : null}
							{this.state.enableVoiceModal ? (
								<VoiceModal
									currentScreen={this.state.currentScreen}
									onClose={() => {
										this.setState({
											enableVoiceModal: false,
										});
									}}
									voiceText={(data) => {
										if (this.state.currentScreen === 'chatscreen') {
											this.setState({
												chatInput: data,
												enableVoiceModal: false,
											});
										} else {
											this.setState({
												voiceText: data,
												enableVoiceModal: false,
											});
										}
									}}
									botId={this.props.botID}
									id={this.state.conversationalId}
								/>
							) : null}
							{this.state.hasSessionExpired && this.state.isChatBodyVisible ? (
								<React.Suspense fallback={<div>Loading...</div>}>
									<SFModal isModalVisible={this.state.isModalVisible}>
										<div className='sf-chatmodal-overlay'>
											<div className='sf-chatmodal-body'>
												<div id='sf-chatmodal-content'>
													<div>
														Your session has expired. Please click on confirm to
														start chat again
													</div>
													<button
														className='sf-chatmodal-btn'
														onClick={this.handleSessionTimer.bind(this, true)}
														style={
															this.state.disableSessionConfirmBtn === false
																? {
																		marginTop: '20px',
																		backgroundColor: this.props.data
																			.launcherPromptBackground
																			? this.props.data.launcherPromptBackground
																			: this.props.data.primaryColo,
																		color: 'white',
																  }
																: {
																		marginTop: '20px',
																		backgroundColor:
																			this.props.data.launcherPromptBackground,
																		color: 'white',
																		opacity: '0.4',
																		pointerEvents: 'none',
																  }
														}
													>
														Confirm
													</button>
												</div>
											</div>
										</div>
									</SFModal>
								</React.Suspense>
							) : null}
							{this.state.collectUserDetails ? (
								<React.Suspense fallback={<div>Loading...</div>}>
									<SFModal isModalVisible={this.state.isModalVisible}>
										<div className='sf-chatmodal-overlay'>
											<div className='sf-chatmodal-body'>
												<div
													style={{
														display: 'flex',
														justifyContent: 'flex-end',
														margin: '4px',
														cursor: 'pointer',
													}}
													onClick={() => {
														this.handleTransferCancel();
													}}
												>
													{/* <img src={CrossIcon} alt="cross icon" /> */}
												</div>
												<div
													id='sf-chatmodal-content'
													style={{ padding: '5px 25px' }}
												>
													<div
														style={{
															fontSize: '13px',
															lineHeight: '1.69',
															fontFamily: 'OpenSans',
															letterSpacing: '-0.2px',
															color: '#000000',
														}}
													>
														Please share the following details before we
														transfer your chat
													</div>
													<form style={{ fontFamily: 'OpenSans' }}>
														{this.state.isUserNameNeeded && (
															<>
																<input
																	name='name'
																	type='text'
																	placeholder='First Name'
																	style={{
																		border: 'none',
																		borderBottom: '1px solid lightgray',
																		paddingTop: '20px',
																		fontSize: '14px',
																		width: '100%',
																		outline: 'none',
																		fontFamily: 'OpenSans',
																	}}
																	className='name'
																	value={this.state.userDetailName}
																	onChange={(event) => {
																		this.setState({
																			userDetailName: event.target.value,
																		});
																	}}
																	maxLength={140}
																	autoFocus={true}
																/>
																<div
																	id='firstname-validation-error'
																	style={{
																		fontSize: '10px',
																		letterSpacing: '-0.15px',
																		textAlign: 'right',
																		color: '#ff0000',
																		height: '10px',
																	}}
																></div>
															</>
														)}
														{this.state.isuserLastNameNeeded && (
															<>
																<input
																	name='email'
																	type='text'
																	placeholder='Last Name'
																	style={{
																		border: 'none',
																		borderBottom: '1px solid lightgray',
																		paddingTop: '20px',
																		fontSize: '14px',
																		width: '100%',
																		outline: 'none',
																		fontFamily: 'OpenSans',
																		marginTop: '5px',
																	}}
																	className='email'
																	value={this.state.userDetailLastName}
																	onChange={(event) => {
																		this.setState({
																			userDetailLastName: event.target.value,
																		});
																	}}
																	autoFocus={
																		this.state.isUserNameNeeded === false
																			? true
																			: false
																	}
																/>
																<div
																	id='lastname-validation-error'
																	style={{
																		fontSize: '10px',
																		letterSpacing: '-0.15px',
																		textAlign: 'right',
																		color: '#ff0000',
																		height: '10px',
																	}}
																></div>
															</>
														)}
														{this.state.isUserContactNeeded && (
															<>
																<div
																	style={{
																		display: 'flex',
																		justifyContent: 'center',
																		alignItems: 'baseline',
																		borderBottom: '1px solid lightgray',
																		outline: 'none',
																		marginTop: '5px',
																	}}
																>
																	<select
																		className='sf-chatmodal-select'
																		onChange={(event) => {
																			this.setState({
																				SelectedCountryCode: event.target.value,
																			});
																		}}
																		style={{ outline: 'none' }}
																	>
																		{this.sortedCountryCodes.map(
																			(country, cidx) => (
																				<option
																					value={'+' + country.callingCodes}
																					selected={
																						country.callingCodes == '91'
																					}
																					key={cidx}
																					style={{
																						// backgroundImage: `url(${country.flag})`,
																						position: 'relative',
																						zIndex: 10000,
																						outline: 'none',
																						fontFamily: 'OpenSans',
																					}}
																				>
																					{'+' + country.callingCodes}
																				</option>
																			)
																		)}
																	</select>
																	<input
																		name='contact_no'
																		type='text'
																		placeholder='Phone number'
																		style={{
																			border: 'none',
																			paddingTop: '20px',
																			fontSize: '14px',
																			width: '100%',
																			outline: 'none',
																			fontFamily: 'OpenSans',
																		}}
																		className='contact_no'
																		value={this.state.userDetailContact}
																		onChange={(event) => {
																			this.setState({
																				userDetailContact: event.target.value,
																			});
																		}}
																		maxLength={10}
																		autoFocus={
																			this.state.isUserNameNeeded === false &&
																			this.state.isuserLastNameNeeded === false
																				? true
																				: false
																		}
																	/>
																</div>
																<div
																	id='contactDetails-validation-error'
																	style={{
																		fontSize: '10px',
																		letterSpacing: '-0.15px',
																		textAlign: 'right',
																		color: '#ff0000',
																		height: '10px',
																	}}
																></div>
															</>
														)}
													</form>
													<button
														className='sf-chatmodal-btn'
														onClick={this.handleUserDetails.bind(this)}
														style={
															this.state.userDetailContact === '' &&
															this.state.userDetailLastName === '' &&
															this.state.userDetailName === ''
																? {
																		margin: '15px 0px',
																		backgroundColor:
																			this.props.data.launcherPromptBackground,
																		color: 'white',
																		fontFamily: 'OpenSans',
																		width: '100%',
																		pointerEvents: 'none',
																		opacity: '0.4',
																  }
																: this.state.disableUserDetailBtn === 'clicked'
																? {
																		margin: '15px 0px',
																		backgroundColor:
																			this.props.data.launcherPromptBackground,
																		color: 'white',
																		fontFamily: 'OpenSans',
																		width: '100%',
																		pointerEvents: 'none',
																		opacity: '0.4',
																  }
																: {
																		marginTop: '42px',
																		backgroundColor:
																			this.props.data.launcherPromptBackground,
																		color: 'white',
																		fontFamily: 'OpenSans',
																		width: '100%',
																  }
														}
													>
														Done
													</button>
												</div>
											</div>
										</div>
									</SFModal>
								</React.Suspense>
							) : null}
						</div>
					</InternationalizationContext.Provider>
				)}
			</div>
		);
	}
}

export default App;
